/* @ts-self-types="./designer.d.ts" */

export class Web {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WebFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_web_free(ptr, 0);
    }
    /**
     * Registers a loaded audio element with the audio engine, mirroring
     * `addVideoResource`. Playback stays silent until the node's `VideoTool`
     * reconciles a node whose clips use this key. Gated to wasm — the element type
     * is browser-only, and native export never loads audio this way — so the
     * export build links no `HtmlAudioElement`.
     * @param {string} resourceKey
     * @param {HTMLAudioElement} audioElement
     * @param {NodeId[]} nodeIds
     */
    addAudioResource(resourceKey, audioElement, nodeIds) {
        const ptr0 = passStringToWasm0(resourceKey, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(nodeIds, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        wasm.web_addAudioResource(this.__wbg_ptr, ptr0, len0, audioElement, ptr1, len1);
    }
    /**
     * Adds an effect of the given type, with its options at their defaults, at
     * the top of the layer's effects.
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     * @param {EffectType} effectType
     * @returns {Edit}
     */
    addEffect(nodeId, layerId, effectType) {
        const ret = wasm.web_addEffect(this.__wbg_ptr, nodeId, layerId, effectType);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {string} resourceKey
     * @param {Uint8Array} fontBytes
     * @param {NodeId[]} nodeIds
     */
    addFontResource(resourceKey, fontBytes, nodeIds) {
        const ptr0 = passStringToWasm0(resourceKey, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArray8ToWasm0(fontBytes, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passArrayJsValueToWasm0(nodeIds, wasm.__wbindgen_malloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.web_addFontResource(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} resourceKey
     * @param {ImageBitmap} imageBitmap
     * @param {NodeId[]} nodeIds
     */
    addImageResource(resourceKey, imageBitmap, nodeIds) {
        const ptr0 = passStringToWasm0(resourceKey, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(nodeIds, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        wasm.web_addImageResource(this.__wbg_ptr, ptr0, len0, imageBitmap, ptr1, len1);
    }
    /**
     * @param {NodeId} targetNodeId
     * @param {InputId} targetInputId
     * @param {DataType[] | null} [validInputTypes]
     * @returns {Edit}
     */
    addInputHandle(targetNodeId, targetInputId, validInputTypes) {
        var ptr0 = isLikeNone(validInputTypes) ? 0 : passArrayJsValueToWasm0(validInputTypes, wasm.__wbindgen_malloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_addInputHandle(this.__wbg_ptr, targetNodeId, targetInputId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Adds one layer showing content the compositor already holds, at the stage
     * center or a given point, and selects it. Placing the same content twice
     * gives two layers on it. Returns a single edit (one undo step).
     *
     * Nothing is added when the compositor does not hold the resource, or when
     * the resource follows a wire that is carrying nothing or has come to carry
     * another media type since the gesture started.
     * @param {NodeId} nodeId
     * @param {ResourceId} resourceId
     * @param {LayerPlacement} placement
     * @returns {Edit}
     */
    addLayerForResource(nodeId, resourceId, placement) {
        const ret = wasm.web_addLayerForResource(this.__wbg_ptr, nodeId, resourceId, placement);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Adds one layer per file, each owning its file inline (no wire), sized to
     * fit the stage and placed at the stage center or a given point. Images,
     * video, and audio are supported; anything else is skipped. Several files
     * cascade so they do not stack exactly. Adding the first timed clip (video
     * or audio) to a still-image compositor turns the timeline on and sets the
     * composition length and frame rate from that clip, matching how connecting
     * a video behaves; the winner is the first timed file in call order, so it
     * is stable regardless of upload-completion order. Returns a single edit
     * (one undo step) and selects the new layers.
     * @param {NodeId} nodeId
     * @param {FileKind[]} files
     * @param {LayerPlacement} placement
     * @returns {Edit}
     */
    addMediaLayers(nodeId, files, placement) {
        const ptr0 = passArrayJsValueToWasm0(files, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_addMediaLayers(this.__wbg_ptr, nodeId, ptr0, len0, placement);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Creates a new text layer at the center of the current viewport and selects it.
     * @param {NodeId} nodeId
     * @param {string} text
     * @returns {Edit}
     */
    addTextLayer(nodeId, text) {
        const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_addTextLayer(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {string} resourceKey
     * @param {Uint8Array} modelBytes
     * @param {NodeId[]} nodeIds
     */
    addThreeDModelResource(resourceKey, modelBytes, nodeIds) {
        const ptr0 = passStringToWasm0(resourceKey, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArray8ToWasm0(modelBytes, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passArrayJsValueToWasm0(nodeIds, wasm.__wbindgen_malloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.web_addThreeDModelResource(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {string} resourceKey
     * @param {HTMLVideoElement} videoElement
     * @param {NodeId[]} nodeIds
     */
    addVideoResource(resourceKey, videoElement, nodeIds) {
        const ptr0 = passStringToWasm0(resourceKey, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(nodeIds, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        wasm.web_addVideoResource(this.__wbg_ptr, ptr0, len0, videoElement, ptr1, len1);
    }
    /**
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @param {Alignment} alignment
     * @returns {Edit}
     */
    alignCompositorLayers(nodeId, layerIds, alignment) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_alignCompositorLayers(this.__wbg_ptr, nodeId, ptr0, len0, alignment);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Sets `snapshot` and `output_image`, and clears any pending snapshot-copy, in one edit so
     * `WasmAPI.onEdit`'s wasm→store round-trip stays lossless.
     * @param {NodeId} nodeId
     * @param {FigmaNodeSnapshot} snapshot
     * @param {ImageFile | null} [outputImage]
     * @returns {Edit}
     */
    applyFigmaNodeInitialize(nodeId, snapshot, outputImage) {
        const ret = wasm.web_applyFigmaNodeInitialize(this.__wbg_ptr, nodeId, snapshot, isLikeNone(outputImage) ? 0 : addToExternrefTable0(outputImage));
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {EditState[]} editState
     * @returns {EditState[]}
     */
    applyUndoRedoEntry(editState) {
        const ptr0 = passArrayJsValueToWasm0(editState, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_applyUndoRedoEntry(this.__wbg_ptr, ptr0, len0);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v2 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v2;
    }
    /**
     * @returns {AudioToLoad[]}
     */
    audiosToLoad() {
        const ret = wasm.web_audiosToLoad(this.__wbg_ptr);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Removes every mask from `layerId`.
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     * @returns {Edit}
     */
    breakLayerMasks(nodeId, layerId) {
        const ret = wasm.web_breakLayerMasks(this.__wbg_ptr, nodeId, layerId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     */
    clearCompositorAiMask(nodeId) {
        wasm.web_clearCompositorAiMask(this.__wbg_ptr, nodeId);
    }
    /**
     * Converts a point on the compositor canvas into a position in stage space, where layer
     * positions live, so content dropped on the canvas lands where the pointer released.
     *
     * `canvasX`/`canvasY` must already be in the drawing-buffer pixel space the camera uses:
     * origin at the bottom-left, y pointing up, scaled to the buffer size. The drop handler
     * produces that by mirroring `canvas_position` in `event_handler.rs`.
     *
     * Returns `None` when the compositor has no active camera, for example when its editor is
     * not open, so the caller can fall back to the stage center.
     * @param {NodeId} nodeId
     * @param {number} canvasX
     * @param {number} canvasY
     * @returns {StagePoint | undefined}
     */
    compositorCanvasPointToStage(nodeId, canvasX, canvasY) {
        const ret = wasm.web_compositorCanvasPointToStage(this.__wbg_ptr, nodeId, canvasX, canvasY);
        return ret;
    }
    /**
     * The layers a distribute of `layerIds` spaces: the given layers, or the
     * children of the layer when only one is given. Locked layers and layers
     * that show nothing, such as audio or an empty group, are left out.
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @returns {LayerId[]}
     */
    compositorDistributionLayerIds(nodeId, layerIds) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_compositorDistributionLayerIds(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v2 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v2;
    }
    /**
     * The box the property panel displays for a group: the bounds of its
     * children's geometry along the group's axes. `None` for any other kind of
     * layer, whose own fields are what it shows.
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     * @returns {GroupBox | undefined}
     */
    compositorGroupBox(nodeId, layerId) {
        const ret = wasm.web_compositorGroupBox(this.__wbg_ptr, nodeId, layerId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {InputId} inputId
     * @returns {Histogram | undefined}
     */
    computeInputHistogram(nodeId, inputId) {
        const ret = wasm.web_computeInputHistogram(this.__wbg_ptr, nodeId, inputId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @returns {Histogram | undefined}
     */
    computeOutputHistogram(nodeId) {
        const ret = wasm.web_computeOutputHistogram(this.__wbg_ptr, nodeId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Converts selected unlocked images without changing their placement or appearance.
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @returns {Edit}
     */
    convertImageLayersToShapes(nodeId, layerIds) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_convertImageLayersToShapes(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Serializes the clonable layers among `layerIds` into an opaque clipboard
     * string the client holds in the app (not the OS clipboard). Each entry is
     * a self-contained subtree snapshot (files by value, the root's world
     * transform baked in, no live ids), so a paste rebuilds fresh ids and never
     * needs the source layers. A whole group is snapshotted, its wired
     * descendants left out. Returns `None` when the selection holds nothing
     * clonable. The client treats the string as opaque; only `pasteLayersPayload`
     * reads it back.
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @returns {string | undefined}
     */
    copyLayersPayload(nodeId, layerIds) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_copyLayersPayload(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        let v2;
        if (ret[0] !== 0) {
            v2 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v2;
    }
    disableNodeEditor() {
        const ret = wasm.web_disableNodeEditor(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * Spaces the layers [`Self::compositorDistributionLayerIds`] picks for
     * `layerIds` evenly along `orientation`: the outermost layers stay where
     * they are, and the ones between them move so the gaps between
     * neighbouring layers are equal.
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @param {Orientation} orientation
     * @returns {Edit}
     */
    distributeCompositorLayers(nodeId, layerIds, orientation) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_distributeCompositorLayers(this.__wbg_ptr, nodeId, ptr0, len0, orientation);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Duplicates the clonable layers among `layerIds` (any layer that owns its
     * content, including a whole group), placing each copy right after its
     * original in the same container and in the same place. Returns one edit
     * (one undo step) and selects the new layers. A wired layer, or a group
     * with nothing clonable inside, is skipped.
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @param {boolean} allowWiredMedia
     * @returns {Edit}
     */
    duplicateLayers(nodeId, layerIds, allowWiredMedia) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_duplicateLayers(this.__wbg_ptr, nodeId, ptr0, len0, allowWiredMedia);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {string} value
     * @returns {Edit}
     */
    editTextAsset(nodeId, value) {
        const ptr0 = passStringToWasm0(value, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_editTextAsset(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     */
    enableNodeEditor(nodeId) {
        const ret = wasm.web_enableNodeEditor(this.__wbg_ptr, nodeId);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {NodeId} nodeId
     * @param {InputId} inputId
     * @returns {EvaluatedValue | undefined}
     */
    evaluateInput(nodeId, inputId) {
        const ret = wasm.web_evaluateInput(this.__wbg_ptr, nodeId, inputId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number | null} [index]
     * @returns {EvaluatedValue | undefined}
     */
    evaluateNode(nodeId, index) {
        const ret = wasm.web_evaluateNode(this.__wbg_ptr, nodeId, isLikeNone(index) ? 0x100000001 : (index) >>> 0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Input} input
     * @returns {EvaluatedValue | undefined}
     */
    evaluateOutput(input) {
        const ret = wasm.web_evaluateOutput(this.__wbg_ptr, input);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {string} parameterId
     * @returns {ParameterValue | undefined}
     */
    evaluateParameter(nodeId, parameterId) {
        const ptr0 = passStringToWasm0(parameterId, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_evaluateParameter(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {string} parameterId
     * @returns {ParameterValue | undefined}
     */
    evaluateValidParameter(nodeId, parameterId) {
        const ptr0 = passStringToWasm0(parameterId, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_evaluateValidParameter(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {OutputId | null} [outputId]
     * @param {number | null} [maxTextureSize]
     * @param {number | null} [generationIndex]
     * @returns {Base64Image | undefined}
     */
    exportNodeRender(nodeId, outputId, maxTextureSize, generationIndex) {
        const ret = wasm.web_exportNodeRender(this.__wbg_ptr, nodeId, isLikeNone(outputId) ? 0 : addToExternrefTable0(outputId), isLikeNone(maxTextureSize) ? 0x100000001 : (maxTextureSize) >>> 0, isLikeNone(generationIndex) ? 0x100000001 : (generationIndex) >>> 0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     */
    fitCompositorAiOutpaintToImage(nodeId) {
        wasm.web_fitCompositorAiOutpaintToImage(this.__wbg_ptr, nodeId);
    }
    /**
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @param {Orientation} orientation
     * @returns {Edit}
     */
    flipCompositorLayers(nodeId, layerIds, orientation) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_flipCompositorLayers(this.__wbg_ptr, nodeId, ptr0, len0, orientation);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {FontToLoad[]}
     */
    fontsToLoad() {
        const ret = wasm.web_fontsToLoad(this.__wbg_ptr);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {NodeId} nodeId
     * @returns {boolean}
     */
    getCanCompareInput(nodeId) {
        const ret = wasm.web_getCanCompareInput(this.__wbg_ptr, nodeId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * @param {NodeId} nodeId
     * @returns {boolean}
     */
    getCanDownloadNode(nodeId) {
        const ret = wasm.web_getCanDownloadNode(this.__wbg_ptr, nodeId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * Groups the currently given layers into a new group layer and selects the new group.
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @returns {Edit}
     */
    groupLayers(nodeId, layerIds) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_groupLayers(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {ImageToLoad[]}
     */
    imagesToLoad() {
        const ret = wasm.web_imagesToLoad(this.__wbg_ptr);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Imports generated images in one transaction without touching selection.
     * @param {NodeId} nodeId
     * @param {ImageFile[]} images
     * @param {LayerId} sourceLayerId
     * @param {string} groupName
     * @param {boolean} wrapInGroup
     * @param {CompositorAiBounds | null} [customBounds]
     * @returns {CompositorAiImportResult}
     */
    importCompositorImages(nodeId, images, sourceLayerId, groupName, wrapInGroup, customBounds) {
        const ptr0 = passArrayJsValueToWasm0(images, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(groupName, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.web_importCompositorImages(this.__wbg_ptr, nodeId, ptr0, len0, sourceLayerId, ptr1, len1, wrapInGroup, isLikeNone(customBounds) ? 0 : addToExternrefTable0(customBounds));
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Graph} graph
     * @returns {Edit}
     */
    importGraph(graph) {
        const ret = wasm.web_importGraph(this.__wbg_ptr, graph);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @returns {InputId[]}
     */
    inputIds(nodeId) {
        const ret = wasm.web_inputIds(this.__wbg_ptr, nodeId);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {InsertNode[]} nodes
     * @returns {Edit}
     */
    insertNodes(nodes) {
        const ptr0 = passArrayJsValueToWasm0(nodes, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_insertNodes(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {InputId} inputId
     * @returns {boolean}
     */
    isInputRequired(nodeId, inputId) {
        const ret = wasm.web_isInputRequired(this.__wbg_ptr, nodeId, inputId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * @param {NodeId} nodeId
     * @param {InputId} inputId
     * @returns {boolean}
     */
    isInputValid(nodeId, inputId) {
        const ret = wasm.web_isInputValid(this.__wbg_ptr, nodeId, inputId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * Whether the layer is locked, either directly or through a locked ancestor.
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     * @returns {boolean}
     */
    isLayerLocked(nodeId, layerId) {
        const ret = wasm.web_isLayerLocked(this.__wbg_ptr, nodeId, layerId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * Whether a locked group holds the layer, whatever its own lock says. Such
     * a layer cannot release itself, only the group can.
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     * @returns {boolean}
     */
    isLayerLockedByAncestor(nodeId, layerId) {
        const ret = wasm.web_isLayerLockedByAncestor(this.__wbg_ptr, nodeId, layerId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * @param {NodeId} nodeId
     * @param {string} parameterId
     * @returns {boolean}
     */
    isParameterExposed(nodeId, parameterId) {
        const ptr0 = passStringToWasm0(parameterId, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_isParameterExposed(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * Whether the shape can currently use a perspective image fill.
     * @param {Layer} layer
     * @returns {boolean}
     */
    isPerspectiveShape(layer) {
        const ret = wasm.web_isPerspectiveShape(this.__wbg_ptr, layer);
        return ret !== 0;
    }
    /**
     * @param {NodeId} nodeId
     * @returns {boolean}
     */
    isVectorEditActive(nodeId) {
        const ret = wasm.web_isVectorEditActive(this.__wbg_ptr, nodeId);
        return ret !== 0;
    }
    /**
     * @param {FontOptions} font
     * @returns {Uint8Array}
     */
    italicSupport(font) {
        const ret = wasm.web_italicSupport(this.__wbg_ptr, font);
        var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    loadMaskResources() {
        const ret = wasm.web_loadMaskResources(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * Moves the layer's effect at `index` to `toIndex`, a place named in the
     * list as it stands with the effect still in it. Effects are drawn in the
     * order they are listed, so this is what changes the order they are applied
     * in. A move landing the effect where it already sits changes nothing.
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     * @param {number} index
     * @param {number} toIndex
     * @returns {Edit}
     */
    moveEffect(nodeId, layerId, index, toIndex) {
        const ret = wasm.web_moveEffect(this.__wbg_ptr, nodeId, layerId, index, toIndex);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Moves the given layers to `index` within `parentId` (top-level when
     * `parentId` is omitted, otherwise that group's children). Supports
     * reordering within a group and moving layers into or out of groups.
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @param {LayerId | null | undefined} parentId
     * @param {number} index
     * @returns {Edit}
     */
    moveLayers(nodeId, layerIds, parentId, index) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_moveLayers(this.__wbg_ptr, nodeId, ptr0, len0, isLikeNone(parentId) ? 0 : addToExternrefTable0(parentId), index);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {InputId} inputId
     * @param {number} toIndex
     * @returns {Edit}
     */
    moveVideoConcatenatorInput(nodeId, inputId, toIndex) {
        const ret = wasm.web_moveVideoConcatenatorInput(this.__wbg_ptr, nodeId, inputId, toIndex);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Function} notify_ui_state_update
     * @param {Function} notify_edit
     * @param {Function} notify_legacy
     * @param {HTMLCanvasElement} canvas
     * @param {boolean} editable
     * @param {boolean} figma_theme_enabled
     */
    constructor(notify_ui_state_update, notify_edit, notify_legacy, canvas, editable, figma_theme_enabled) {
        const ret = wasm.web_new(notify_ui_state_update, notify_edit, notify_legacy, canvas, editable, figma_theme_enabled);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0] >>> 0;
        WebFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {NodeId} nodeId
     * @param {InputId} inputId
     * @returns {Input | undefined}
     */
    nodeInput(nodeId, inputId) {
        const ret = wasm.web_nodeInput(this.__wbg_ptr, nodeId, inputId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {InputId} inputId
     * @returns {DataType | undefined}
     */
    nodeInputType(nodeId, inputId) {
        const ret = wasm.web_nodeInputType(this.__wbg_ptr, nodeId, inputId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {OutputId} outputId
     * @returns {DataType | undefined}
     */
    nodeOutputType(nodeId, outputId) {
        const ret = wasm.web_nodeOutputType(this.__wbg_ptr, nodeId, outputId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {InputId} inputId
     * @returns {DataType[]}
     */
    nodeValidInputTypes(nodeId, inputId) {
        const ret = wasm.web_nodeValidInputTypes(this.__wbg_ptr, nodeId, inputId);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Nudges the given layers by `(dx, dy)` in the space their panel X/Y live
     * in. A group moves through its derived box; content layers add the delta
     * to their stored position.
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @param {number} dx
     * @param {number} dy
     * @returns {Edit}
     */
    offsetCompositorLayerPositions(nodeId, layerIds, dx, dy) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_offsetCompositorLayerPositions(this.__wbg_ptr, nodeId, ptr0, len0, dx, dy);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    onBlur() {
        wasm.web_onBlur(this.__wbg_ptr);
    }
    /**
     * Removes the pending AI action for a layer.
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     * @param {boolean} discardActionState
     */
    onDoneCompositorAiAction(nodeId, layerId, discardActionState) {
        wasm.web_onDoneCompositorAiAction(this.__wbg_ptr, nodeId, layerId, discardActionState);
    }
    /**
     * @param {MouseEvent} event
     */
    onDoubleClick(event) {
        wasm.web_onDoubleClick(this.__wbg_ptr, event);
    }
    /**
     * @param {KeyboardEvent} event
     * @returns {boolean}
     */
    onKeyDown(event) {
        const ret = wasm.web_onKeyDown(this.__wbg_ptr, event);
        return ret !== 0;
    }
    /**
     * @param {KeyboardEvent} event
     */
    onKeyUp(event) {
        wasm.web_onKeyUp(this.__wbg_ptr, event);
    }
    /**
     * @param {PointerEvent} event
     */
    onPointerDown(event) {
        wasm.web_onPointerDown(this.__wbg_ptr, event);
    }
    /**
     * @param {PointerEvent} event
     */
    onPointerEnter(event) {
        wasm.web_onPointerEnter(this.__wbg_ptr, event);
    }
    /**
     * @param {PointerEvent} event
     */
    onPointerLeave(event) {
        wasm.web_onPointerLeave(this.__wbg_ptr, event);
    }
    /**
     * @param {PointerEvent} event
     */
    onPointerMove(event) {
        wasm.web_onPointerMove(this.__wbg_ptr, event);
    }
    /**
     * @param {PointerEvent} event
     */
    onPointerUp(event) {
        wasm.web_onPointerUp(this.__wbg_ptr, event);
    }
    /**
     * Captures the current AI action and returns its action-specific data.
     * @param {NodeId} nodeId
     * @returns {CompositorAiSubmitResult | undefined}
     */
    onSubmitCompositorAiAction(nodeId) {
        const ret = wasm.web_onSubmitCompositorAiAction(this.__wbg_ptr, nodeId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {WheelEvent} event
     */
    onWheel(event) {
        wasm.web_onWheel(this.__wbg_ptr, event);
    }
    /**
     * @param {NodeId} nodeId
     * @returns {OutputId[]}
     */
    outputIds(nodeId) {
        const ret = wasm.web_outputIds(this.__wbg_ptr, nodeId);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {NodeId} nodeId
     * @param {string} parameterId
     * @returns {ParameterConstraint | undefined}
     */
    parameterConstraint(nodeId, parameterId) {
        const ptr0 = passStringToWasm0(parameterId, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_parameterConstraint(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @returns {string[]}
     */
    parameterIds(nodeId) {
        const ret = wasm.web_parameterIds(this.__wbg_ptr, nodeId);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Pastes the layers from a clipboard payload built by `copyLayersPayload`,
     * inserting each at the top level where it sat when it was copied, and
     * selecting them. One edit (one undo step). Works across compositors in the
     * same session. An unreadable payload, or one holding nothing clonable, is
     * ignored (empty edit).
     * @param {NodeId} nodeId
     * @param {string} payload
     * @returns {Edit}
     */
    pasteLayersPayload(nodeId, payload) {
        const ptr0 = passStringToWasm0(payload, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_pasteLayersPayload(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    redraw() {
        wasm.web_redraw(this.__wbg_ptr);
    }
    /**
     * Removes the layer's effect at `index`. An index past the end names no
     * effect, and nothing happens.
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     * @param {number} index
     * @returns {Edit}
     */
    removeEffect(nodeId, layerId, index) {
        const ret = wasm.web_removeEffect(this.__wbg_ptr, nodeId, layerId, index);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} targetNodeId
     * @param {InputId} targetInputId
     * @returns {Edit}
     */
    removeInputHandle(targetNodeId, targetInputId) {
        const ret = wasm.web_removeInputHandle(this.__wbg_ptr, targetNodeId, targetInputId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Removes the given layers, and what is inside them. With `keepWiredMedia`
     * set, media fed by a connected node is lifted out and kept instead of
     * removed, for a caller that has no way to place it again.
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @param {boolean} keepWiredMedia
     * @returns {Edit}
     */
    removeLayers(nodeId, layerIds, keepWiredMedia) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_removeLayers(this.__wbg_ptr, nodeId, ptr0, len0, keepWiredMedia);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId[]} nodeIds
     * @returns {Edit}
     */
    removeNodes(nodeIds) {
        const ptr0 = passArrayJsValueToWasm0(nodeIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_removeNodes(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Removes content the compositor holds, together with every layer showing
     * it, in one edit (one undo step) so one undo brings all of them back. A
     * locked layer and one nested in a group go too; the removed layers' own
     * children are lifted into their place and survive.
     *
     * Content that follows a wire is left alone: reconciliation would build a
     * layer for it again. Content that is already gone is left alone too. In
     * both of those cases nothing at all happens, not even an empty edit.
     * @param {NodeId} nodeId
     * @param {ResourceId} resourceId
     * @returns {Edit}
     */
    removeResource(nodeId, resourceId) {
        const ret = wasm.web_removeResource(this.__wbg_ptr, nodeId, resourceId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Re-key a direct-loaded 3D model from its temp `local:` key to the CDN url
     * once the background upload resolves, avoiding a re-download. Returns `true`
     * when the model was actually re-keyed; `false` means the temp model wasn't
     * present (e.g. still parsing), so the caller falls back to a CDN fetch.
     * @param {string} tempKey
     * @param {string} url
     * @returns {boolean}
     */
    renameThreeDModelResource(tempKey, url) {
        const ptr0 = passStringToWasm0(tempKey, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.web_renameThreeDModelResource(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return ret !== 0;
    }
    /**
     * @param {NodeId} nodeId
     */
    resetCamera(nodeId) {
        const ret = wasm.web_resetCamera(this.__wbg_ptr, nodeId);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {NodeId} nodeId
     * @returns {Edit}
     */
    resetPainterMarks(nodeId) {
        const ret = wasm.web_resetPainterMarks(this.__wbg_ptr, nodeId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Resumes the audio context so playback is audible. Call this from a user
     * gesture (e.g. the play button): a context created outside a gesture starts
     * suspended and the browser keeps it silent until it is resumed under one.
     * A no-op when the audio-engine flag is off, so it never creates a context
     * for a flag-off session.
     */
    resumeAudio() {
        wasm.web_resumeAudio(this.__wbg_ptr);
    }
    /**
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @returns {Edit}
     */
    rotateCompositorLayers90Clockwise(nodeId, layerIds) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_rotateCompositorLayers90Clockwise(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {BlendOptions} options
     * @returns {Edit}
     */
    setBlendOptions(nodeId, options) {
        const ret = wasm.web_setBlendOptions(this.__wbg_ptr, nodeId, options);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {BlurOptions} options
     * @returns {Edit}
     */
    setBlurOptions(nodeId, options) {
        const ret = wasm.web_setBlurOptions(this.__wbg_ptr, nodeId, options);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} fov
     * @returns {Edit}
     */
    setCameraFov(nodeId, fov) {
        const ret = wasm.web_setCameraFov(this.__wbg_ptr, nodeId, fov);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {boolean} locked
     * @returns {Edit}
     */
    setCameraLocked(nodeId, locked) {
        const ret = wasm.web_setCameraLocked(this.__wbg_ptr, nodeId, locked);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {CameraMode} mode
     */
    setCameraMode(nodeId, mode) {
        wasm.web_setCameraMode(this.__wbg_ptr, nodeId, mode);
    }
    /**
     * @param {NodeId} nodeId
     * @param {Channel} channel
     * @returns {Edit}
     */
    setChannel(nodeId, channel) {
        const ret = wasm.web_setChannel(this.__wbg_ptr, nodeId, channel);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {ColorCorrectionOptions} options
     * @returns {Edit}
     */
    setColorCorrectionOptions(nodeId, options) {
        const ret = wasm.web_setColorCorrectionOptions(this.__wbg_ptr, nodeId, options);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {Color[]} colors
     * @returns {Edit}
     */
    setColorPaletteColors(nodeId, colors) {
        const ptr0 = passArrayJsValueToWasm0(colors, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_setColorPaletteColors(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {boolean} showInput
     * @returns {Edit}
     */
    setCompareInput(nodeId, showInput) {
        const ret = wasm.web_setCompareInput(this.__wbg_ptr, nodeId, showInput);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {ComparisonMode} mode
     * @returns {Edit}
     */
    setComparisonMode(nodeId, mode) {
        const ret = wasm.web_setComparisonMode(this.__wbg_ptr, nodeId, mode);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     * @param {CompositorAiActionKind | null} [actionType]
     */
    setCompositorAiAction(nodeId, layerId, actionType) {
        const ret = wasm.web_setCompositorAiAction(this.__wbg_ptr, nodeId, layerId, isLikeNone(actionType) ? 0 : addToExternrefTable0(actionType));
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} size
     */
    setCompositorAiBrushSize(nodeId, size) {
        wasm.web_setCompositorAiBrushSize(this.__wbg_ptr, nodeId, size);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number | null} [ratio]
     */
    setCompositorAiOutpaintAspectRatio(nodeId, ratio) {
        wasm.web_setCompositorAiOutpaintAspectRatio(this.__wbg_ptr, nodeId, isLikeNone(ratio) ? 0x100000001 : Math.fround(ratio));
    }
    /**
     * @param {NodeId} nodeId
     * @param {Color | null} [color]
     * @returns {Edit}
     */
    setCompositorBackgroundColor(nodeId, color) {
        const ret = wasm.web_setCompositorBackgroundColor(this.__wbg_ptr, nodeId, isLikeNone(color) ? 0 : addToExternrefTable0(color));
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} duration
     * @returns {Edit}
     */
    setCompositorDuration(nodeId, duration) {
        const ret = wasm.web_setCompositorDuration(this.__wbg_ptr, nodeId, duration);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} fps
     * @returns {Edit}
     */
    setCompositorFps(nodeId, fps) {
        const ret = wasm.web_setCompositorFps(this.__wbg_ptr, nodeId, fps);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {CropOptions} options
     * @returns {Edit}
     */
    setCropOptions(nodeId, options) {
        const ret = wasm.web_setCropOptions(this.__wbg_ptr, nodeId, options);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {CustomFontEntry[]} entries
     */
    setCustomFonts(entries) {
        const ptr0 = passArrayJsValueToWasm0(entries, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.web_setCustomFonts(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {NodeId} nodeId
     * @param {DefaultFrame} defaultFrame
     * @returns {Edit}
     */
    setCustomGlslDefaultFrame(nodeId, defaultFrame) {
        const ret = wasm.web_setCustomGlslDefaultFrame(this.__wbg_ptr, nodeId, defaultFrame);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {GlslSpec} spec
     * @returns {Edit}
     */
    setCustomGlslSpec(nodeId, spec) {
        const ret = wasm.web_setCustomGlslSpec(this.__wbg_ptr, nodeId, spec);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} size
     * @returns {Edit}
     */
    setDilationErosionSize(nodeId, size) {
        const ret = wasm.web_setDilationErosionSize(this.__wbg_ptr, nodeId, size);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} width
     * @param {number} height
     * @returns {Edit}
     */
    setDimensions(nodeId, width, height) {
        const ret = wasm.web_setDimensions(this.__wbg_ptr, nodeId, width, height);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {boolean} editable
     */
    setEditable(editable) {
        wasm.web_setEditable(this.__wbg_ptr, editable);
    }
    /**
     * Draws the layer's effect at `index`, or stops drawing it, keeping the
     * effect either way. An index past the end names no effect, and nothing
     * happens.
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     * @param {number} index
     * @param {boolean} enabled
     * @returns {Edit}
     */
    setEffectEnabled(nodeId, layerId, index, enabled) {
        const ret = wasm.web_setEffectEnabled(this.__wbg_ptr, nodeId, layerId, index, enabled);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Replaces the options of the layer's effect at `index`, keeping whether it
     * is drawn and where it sits. An index past the end names no effect, and
     * nothing happens.
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     * @param {number} index
     * @param {EffectKind} kind
     * @returns {Edit}
     */
    setEffectKind(nodeId, layerId, index, kind) {
        const ret = wasm.web_setEffectKind(this.__wbg_ptr, nodeId, layerId, index, kind);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {ConnectedFigmaFrame | null} [connectedFigmaFrame]
     * @returns {Edit}
     */
    setFigmaNodeConnectedFigmaFrame(nodeId, connectedFigmaFrame) {
        const ret = wasm.web_setFigmaNodeConnectedFigmaFrame(this.__wbg_ptr, nodeId, isLikeNone(connectedFigmaFrame) ? 0 : addToExternrefTable0(connectedFigmaFrame));
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {ImageFile | null} [outputImage]
     * @returns {Edit}
     */
    setFigmaNodeOutputImage(nodeId, outputImage) {
        const ret = wasm.web_setFigmaNodeOutputImage(this.__wbg_ptr, nodeId, isLikeNone(outputImage) ? 0 : addToExternrefTable0(outputImage));
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {FigmaNodeSnapshot} snapshot
     * @returns {Edit}
     */
    setFigmaNodeSnapshot(nodeId, snapshot) {
        const ret = wasm.web_setFigmaNodeSnapshot(this.__wbg_ptr, nodeId, snapshot);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {FileKind[]} files
     * @returns {Edit}
     */
    setFiles(nodeId, files) {
        const ptr0 = passArrayJsValueToWasm0(files, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_setFiles(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {boolean} enabled
     * @returns {Edit}
     */
    setIsCompositorTimelineEnabled(nodeId, enabled) {
        const ret = wasm.web_setIsCompositorTimelineEnabled(this.__wbg_ptr, nodeId, enabled);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {boolean} value
     * @returns {Edit}
     */
    setIsIterator(nodeId, value) {
        const ret = wasm.web_setIsIterator(this.__wbg_ptr, nodeId, value);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {KeyframeMode} mode
     * @returns {Edit}
     */
    setKeyframeMode(nodeId, mode) {
        const ret = wasm.web_setKeyframeMode(this.__wbg_ptr, nodeId, mode);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} timestamp_seconds
     * @returns {Edit}
     */
    setKeyframeTimestamp(nodeId, timestamp_seconds) {
        const ret = wasm.web_setKeyframeTimestamp(this.__wbg_ptr, nodeId, timestamp_seconds);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Uses `sourceLayerId` as an alpha matte for `targetLayerId`.
     * @param {NodeId} nodeId
     * @param {LayerId} sourceLayerId
     * @param {LayerId} targetLayerId
     * @returns {Edit}
     */
    setLayerMask(nodeId, sourceLayerId, targetLayerId) {
        const ret = wasm.web_setLayerMask(this.__wbg_ptr, nodeId, sourceLayerId, targetLayerId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {LevelsOptions} options
     * @returns {Edit}
     */
    setLevelsOptions(nodeId, options) {
        const ret = wasm.web_setLevelsOptions(this.__wbg_ptr, nodeId, options);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {string[]} list
     * @param {string} delimiter
     * @returns {Edit}
     */
    setListSelector(nodeId, list, delimiter) {
        const ptr0 = passArrayJsValueToWasm0(list, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(delimiter, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.web_setListSelector(this.__wbg_ptr, nodeId, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {string[]} list
     * @returns {Edit}
     */
    setListSelectorList(nodeId, list) {
        const ptr0 = passArrayJsValueToWasm0(list, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_setListSelectorList(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} value
     * @returns {Edit}
     */
    setLoraWeight(nodeId, value) {
        const ret = wasm.web_setLoraWeight(this.__wbg_ptr, nodeId, value);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {Lora[]} value
     * @returns {Edit}
     */
    setLoras(nodeId, value) {
        const ptr0 = passArrayJsValueToWasm0(value, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_setLoras(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {MaskExtractorDisplayMode} mode
     * @returns {Edit}
     */
    setMaskExtractorDisplayMode(nodeId, mode) {
        const ret = wasm.web_setMaskExtractorDisplayMode(this.__wbg_ptr, nodeId, mode);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {MaskExtractorState} state
     * @returns {Edit}
     */
    setMaskExtractorState(nodeId, state) {
        const ret = wasm.web_setMaskExtractorState(this.__wbg_ptr, nodeId, state);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {AiModelInfo} value
     * @param {InputSchema[]} inputs
     * @param {ParameterSchema[]} parameters
     * @param {OutputSchema[]} outputs
     * @returns {Edit}
     */
    setModel(nodeId, value, inputs, parameters, outputs) {
        const ptr0 = passArrayJsValueToWasm0(inputs, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(parameters, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ptr2 = passArrayJsValueToWasm0(outputs, wasm.__wbindgen_malloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.web_setModel(this.__wbg_ptr, nodeId, value, ptr0, len0, ptr1, len1, ptr2, len2);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {ModelAsset[]} generations
     * @returns {Edit}
     */
    setModelGenerations(nodeId, generations) {
        const ptr0 = passArrayJsValueToWasm0(generations, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_setModelGenerations(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} index
     * @param {HTMLCanvasElement | null} [canvas]
     */
    setNodeCanvas(nodeId, index, canvas) {
        wasm.web_setNodeCanvas(this.__wbg_ptr, nodeId, index, isLikeNone(canvas) ? 0 : addToExternrefTable0(canvas));
    }
    /**
     * @param {NodeId} targetNodeId
     * @param {InputId} targetInputId
     * @param {Input | null} [input]
     * @param {boolean | null} [isReconnect]
     * @returns {Edit}
     */
    setNodeInput(targetNodeId, targetInputId, input, isReconnect) {
        const ret = wasm.web_setNodeInput(this.__wbg_ptr, targetNodeId, targetInputId, isLikeNone(input) ? 0 : addToExternrefTable0(input), isLikeNone(isReconnect) ? 0xFFFFFF : isReconnect ? 1 : 0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {NodeId | null} [parentId]
     * @returns {Edit}
     */
    setNodeParent(nodeId, parentId) {
        const ret = wasm.web_setNodeParent(this.__wbg_ptr, nodeId, isLikeNone(parentId) ? 0 : addToExternrefTable0(parentId));
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} index
     * @param {number} time
     * @param {boolean} ongoing
     */
    setNodeVideoTime(nodeId, index, time, ongoing) {
        const ret = wasm.web_setNodeVideoTime(this.__wbg_ptr, nodeId, index, time, ongoing);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {NodeId} nodeId
     * @param {Number} value
     * @returns {Edit}
     */
    setNumber(nodeId, value) {
        const ret = wasm.web_setNumber(this.__wbg_ptr, nodeId, value);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {PainterMode} mode
     */
    setPainterMode(nodeId, mode) {
        wasm.web_setPainterMode(this.__wbg_ptr, nodeId, mode);
    }
    /**
     * @param {NodeId} nodeId
     * @param {PainterOptions} options
     * @returns {Edit}
     */
    setPainterOptions(nodeId, options) {
        const ret = wasm.web_setPainterOptions(this.__wbg_ptr, nodeId, options);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {string} parameter_id
     * @param {ParameterValue} value
     * @returns {Edit}
     */
    setParameterValue(nodeId, parameter_id, value) {
        const ptr0 = passStringToWasm0(parameter_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_setParameterValue(this.__wbg_ptr, nodeId, ptr0, len0, value);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {PointCloudOptions} options
     * @returns {Edit}
     */
    setPointCloudOptions(nodeId, options) {
        const ret = wasm.web_setPointCloudOptions(this.__wbg_ptr, nodeId, options);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Updates preview backgrounds and redraws existing nodes without editing the graph.
     * @param {boolean} light
     */
    setPreviewLightMode(light) {
        wasm.web_setPreviewLightMode(this.__wbg_ptr, light);
    }
    /**
     * @param {NodeId} nodeId
     * @param {string} value
     * @returns {Edit}
     */
    setPrompt(nodeId, value) {
        const ptr0 = passStringToWasm0(value, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_setPrompt(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {string} value
     * @returns {Edit}
     */
    setPromptConcatenator(nodeId, value) {
        const ptr0 = passStringToWasm0(value, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_setPromptConcatenator(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {PromptDisplayMode} mode
     * @returns {Edit}
     */
    setPromptDisplayMode(nodeId, mode) {
        const ret = wasm.web_setPromptDisplayMode(this.__wbg_ptr, nodeId, mode);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {ResizeOptions} options
     * @returns {Edit}
     */
    setResizeOptions(nodeId, options) {
        const ret = wasm.web_setResizeOptions(this.__wbg_ptr, nodeId, options);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {RotateOptions} options
     * @returns {Edit}
     */
    setRotateOptions(nodeId, options) {
        const ret = wasm.web_setRotateOptions(this.__wbg_ptr, nodeId, options);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {Seed} value
     * @returns {Edit}
     */
    setSeed(nodeId, value) {
        const ret = wasm.web_setSeed(this.__wbg_ptr, nodeId, value);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} value
     * @returns {Edit}
     */
    setSelected(nodeId, value) {
        const ret = wasm.web_setSelected(this.__wbg_ptr, nodeId, value);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} value
     * @returns {Edit}
     */
    setSelectedIndex(nodeId, value) {
        const ret = wasm.web_setSelectedIndex(this.__wbg_ptr, nodeId, value);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     */
    setSelectedLayers(nodeId, layerIds) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_setSelectedLayers(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} selected
     * @returns {Edit}
     */
    setSelectedMedia(nodeId, selected) {
        const ret = wasm.web_setSelectedMedia(this.__wbg_ptr, nodeId, selected);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Shows or hides the reference grid in a node's 3D viewport.
     * @param {NodeId} nodeId
     * @param {boolean} showGrid
     */
    setShowGrid(nodeId, showGrid) {
        wasm.web_setShowGrid(this.__wbg_ptr, nodeId, showGrid);
    }
    /**
     * Sets whether resizing the stage keeps its aspect ratio.
     * @param {NodeId} nodeId
     * @param {boolean} locked
     * @returns {Edit}
     */
    setStageAspectRatioLocked(nodeId, locked) {
        const ret = wasm.web_setStageAspectRatioLocked(this.__wbg_ptr, nodeId, locked);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} width
     * @param {number} height
     * @returns {Edit}
     */
    setStageDimensions(nodeId, width, height) {
        const ret = wasm.web_setStageDimensions(this.__wbg_ptr, nodeId, width, height);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {string[]} array
     * @param {string} delimiter
     * @returns {Edit}
     */
    setStringArray(nodeId, array, delimiter) {
        const ptr0 = passArrayJsValueToWasm0(array, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(delimiter, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.web_setStringArray(this.__wbg_ptr, nodeId, ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {string} value
     * @returns {Edit}
     */
    setText(nodeId, value) {
        const ptr0 = passStringToWasm0(value, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_setText(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {boolean} value
     * @returns {Edit}
     */
    setToggle(nodeId, value) {
        const ret = wasm.web_setToggle(this.__wbg_ptr, nodeId, value);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {ToolMode} mode
     */
    setToolMode(nodeId, mode) {
        const ret = wasm.web_setToolMode(this.__wbg_ptr, nodeId, mode);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} trimStart
     * @param {number} trimEnd
     * @returns {Edit}
     */
    setTrim(nodeId, trimStart, trimEnd) {
        const ret = wasm.web_setTrim(this.__wbg_ptr, nodeId, trimStart, trimEnd);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {ImageMode} scaleMode
     * @returns {Edit}
     */
    setVideoConcatenatorScaleMode(nodeId, scaleMode) {
        const ret = wasm.web_setVideoConcatenatorScaleMode(this.__wbg_ptr, nodeId, scaleMode);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {string} parameterId
     * @param {ParameterConstraint} constraint
     * @param {ParameterValue} defaultValue
     * @returns {Edit}
     */
    setWildcardParameterConstraint(nodeId, parameterId, constraint, defaultValue) {
        const ptr0 = passStringToWasm0(parameterId, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_setWildcardParameterConstraint(this.__wbg_ptr, nodeId, ptr0, len0, constraint, defaultValue);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} zoomLevel
     */
    setZoomLevel(nodeId, zoomLevel) {
        wasm.web_setZoomLevel(this.__wbg_ptr, nodeId, zoomLevel);
    }
    /**
     * @param {NodeId} nodeId
     * @param {boolean} shouldShow
     */
    showHideVectorEditInterface(nodeId, shouldShow) {
        wasm.web_showHideVectorEditInterface(this.__wbg_ptr, nodeId, shouldShow);
    }
    /**
     * @returns {ThreeDModelToLoad[]}
     */
    threeDModelsToLoad() {
        const ret = wasm.web_threeDModelsToLoad(this.__wbg_ptr);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {NodeId} nodeId
     * @returns {Edit}
     */
    toggleNodeLocked(nodeId) {
        const ret = wasm.web_toggleNodeLocked(this.__wbg_ptr, nodeId);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} index
     */
    toggleNodeVideoMute(nodeId, index) {
        wasm.web_toggleNodeVideoMute(this.__wbg_ptr, nodeId, index);
    }
    /**
     * @param {NodeId} nodeId
     * @param {number} index
     */
    toggleNodeVideoPlay(nodeId, index) {
        const ret = wasm.web_toggleNodeVideoPlay(this.__wbg_ptr, nodeId, index);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * Ungroups each of `layerIds`, lifting its children out in its place (a
     * group is removed; any other kind is kept), and selects the resulting
     * layers.
     * @param {NodeId} nodeId
     * @param {LayerId[]} layerIds
     * @returns {Edit}
     */
    ungroupLayers(nodeId, layerIds) {
        const ptr0 = passArrayJsValueToWasm0(layerIds, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.web_ungroupLayers(this.__wbg_ptr, nodeId, ptr0, len0);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {number} dt_ms
     */
    update(dt_ms) {
        const ret = wasm.web_update(this.__wbg_ptr, dt_ms);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * Writes `layer`'s fields to `layerId`. A group has no position or size of
     * its own, so those two fields are the box it shows, the one
     * `compositorGroupBox` reads back, and they land by moving or scaling what
     * the group holds. A group holding no geometry has no box to move or size.
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     * @param {Layer} layer
     * @returns {Edit}
     */
    updateLayer(nodeId, layerId, layer) {
        const ret = wasm.web_updateLayer(this.__wbg_ptr, nodeId, layerId, layer);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Replaces a whole node; only for applying server-computed deltas (graph_changed). Edit through the per-field setters.
     * @param {NodeId} nodeId
     * @param {Node} node
     * @returns {Edit}
     */
    updateNode(nodeId, node) {
        const ret = wasm.web_updateNode(this.__wbg_ptr, nodeId, node);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {NodeId} targetNodeId
     * @param {InputId} targetInputId
     * @param {FileKind | null} [file]
     * @param {string | null} [string]
     * @param {string[] | null} [array]
     * @returns {Edit}
     */
    updateNodeInput(targetNodeId, targetInputId, file, string, array) {
        var ptr0 = isLikeNone(string) ? 0 : passStringToWasm0(string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(array) ? 0 : passArrayJsValueToWasm0(array, wasm.__wbindgen_malloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.web_updateNodeInput(this.__wbg_ptr, targetNodeId, targetInputId, isLikeNone(file) ? 0 : addToExternrefTable0(file), ptr0, len0, ptr1, len1);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Resource keys (URLs) of every video actually feeding the given node's output, independent
     * of the renderer's load state — a gallery node (Import, MediaIterator, AiModel) contributes
     * only its selected file, since the rest never reach this node's output.
     * @param {NodeId} node_id
     * @returns {string[]}
     */
    videoDependencies(node_id) {
        const ret = wasm.web_videoDependencies(this.__wbg_ptr, node_id);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {VideoToLoad[]}
     */
    videosToLoad() {
        const ret = wasm.web_videosToLoad(this.__wbg_ptr);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {FontOptions} font
     * @returns {Uint16Array}
     */
    weightSupport(font) {
        const ret = wasm.web_weightSupport(this.__wbg_ptr, font);
        var v1 = getArrayU16FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 2, 2);
        return v1;
    }
    /**
     * @param {NodeId} nodeId
     */
    zoomToFit(nodeId) {
        const ret = wasm.web_zoomToFit(this.__wbg_ptr, nodeId);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {NodeId} nodeId
     * @param {LayerId} layerId
     */
    zoomToLayer(nodeId, layerId) {
        const ret = wasm.web_zoomToLayer(this.__wbg_ptr, nodeId, layerId);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
}
if (Symbol.dispose) Web.prototype[Symbol.dispose] = Web.prototype.free;

/**
 * @param {ModelNodeType} modelType
 * @returns {DataType[]}
 */
export function allValidInputTypesForModelType(modelType) {
    const ret = wasm.allValidInputTypesForModelType(modelType);
    var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * @param {NodeType} nodeType
 * @returns {DataType[]}
 */
export function allValidInputTypesForNodeType(nodeType) {
    const ret = wasm.allValidInputTypesForNodeType(nodeType);
    var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * @returns {string[]}
 */
export function anyLlmModels() {
    const ret = wasm.anyLlmModels();
    var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * @returns {ModelNodeType[]}
 */
export function modelTypes() {
    const ret = wasm.modelTypes();
    var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * @returns {NodeType[]}
 */
export function nodeTypes() {
    const ret = wasm.nodeTypes();
    var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * @param {Function} callback
 */
export function setAnalytics(callback) {
    wasm.setAnalytics(callback);
}

/**
 * @param {Function} resolver
 */
export function setFeatureFlags(resolver) {
    wasm.setFeatureFlags(resolver);
}

/**
 * @param {Function} logger
 */
export function setLogger(logger) {
    wasm.setLogger(logger);
}

/**
 * Overrides an embedded shader source for development-time hot reloading.
 * @param {string} path
 * @param {string} source
 */
export function setShaderOverride(path, source) {
    const ptr0 = passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passStringToWasm0(source, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    wasm.setShaderOverride(ptr0, len0, ptr1, len1);
}

export function start() {
    wasm.start();
}
function __wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg_Error_960c155d3d49e4c2: function(arg0, arg1) {
            const ret = Error(getStringFromWasm0(arg0, arg1));
            return ret;
        },
        __wbg_Number_32bf70a599af1d4b: function(arg0) {
            const ret = Number(arg0);
            return ret;
        },
        __wbg_String_8564e559799eccda: function(arg0, arg1) {
            const ret = String(arg1);
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_bigint_get_as_i64_3d3aba5d616c6a51: function(arg0, arg1) {
            const v = arg1;
            const ret = typeof(v) === 'bigint' ? v : undefined;
            getDataViewMemory0().setBigInt64(arg0 + 8 * 1, isLikeNone(ret) ? BigInt(0) : ret, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
        },
        __wbg___wbindgen_boolean_get_6ea149f0a8dcc5ff: function(arg0) {
            const v = arg0;
            const ret = typeof(v) === 'boolean' ? v : undefined;
            return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
        },
        __wbg___wbindgen_debug_string_ab4b34d23d6778bd: function(arg0, arg1) {
            const ret = debugString(arg1);
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_in_a5d8b22e52b24dd1: function(arg0, arg1) {
            const ret = arg0 in arg1;
            return ret;
        },
        __wbg___wbindgen_is_bigint_ec25c7f91b4d9e93: function(arg0) {
            const ret = typeof(arg0) === 'bigint';
            return ret;
        },
        __wbg___wbindgen_is_function_3baa9db1a987f47d: function(arg0) {
            const ret = typeof(arg0) === 'function';
            return ret;
        },
        __wbg___wbindgen_is_object_63322ec0cd6ea4ef: function(arg0) {
            const val = arg0;
            const ret = typeof(val) === 'object' && val !== null;
            return ret;
        },
        __wbg___wbindgen_is_string_6df3bf7ef1164ed3: function(arg0) {
            const ret = typeof(arg0) === 'string';
            return ret;
        },
        __wbg___wbindgen_is_undefined_29a43b4d42920abd: function(arg0) {
            const ret = arg0 === undefined;
            return ret;
        },
        __wbg___wbindgen_jsval_eq_d3465d8a07697228: function(arg0, arg1) {
            const ret = arg0 === arg1;
            return ret;
        },
        __wbg___wbindgen_jsval_loose_eq_cac3565e89b4134c: function(arg0, arg1) {
            const ret = arg0 == arg1;
            return ret;
        },
        __wbg___wbindgen_number_get_c7f42aed0525c451: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof(obj) === 'number' ? obj : undefined;
            getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
        },
        __wbg___wbindgen_string_get_7ed5322991caaec5: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof(obj) === 'string' ? obj : undefined;
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg___wbindgen_throw_6b64449b9b9ed33c: function(arg0, arg1) {
            throw new Error(getStringFromWasm0(arg0, arg1));
        },
        __wbg__wbg_cb_unref_b46c9b5a9f08ec37: function(arg0) {
            arg0._wbg_cb_unref();
        },
        __wbg_activeElement_737cd2e5ce862ac0: function(arg0) {
            const ret = arg0.activeElement;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_activeTexture_3df5a43f55a69a6c: function(arg0, arg1) {
            arg0.activeTexture(arg1 >>> 0);
        },
        __wbg_activeTexture_546afc38eb98df71: function(arg0, arg1) {
            arg0.activeTexture(arg1 >>> 0);
        },
        __wbg_addEventListener_8176dab41b09531c: function() { return handleError(function (arg0, arg1, arg2, arg3) {
            arg0.addEventListener(getStringFromWasm0(arg1, arg2), arg3);
        }, arguments); },
        __wbg_altKey_3116112ec764f316: function(arg0) {
            const ret = arg0.altKey;
            return ret;
        },
        __wbg_altKey_c4f26b40f1b826b4: function(arg0) {
            const ret = arg0.altKey;
            return ret;
        },
        __wbg_appendChild_e95c8b3b936d250a: function() { return handleError(function (arg0, arg1) {
            const ret = arg0.appendChild(arg1);
            return ret;
        }, arguments); },
        __wbg_attachShader_1eec3a0d2bfe6f83: function(arg0, arg1, arg2) {
            arg0.attachShader(arg1, arg2);
        },
        __wbg_attachShader_e1c4cb1f00f167df: function(arg0, arg1, arg2) {
            arg0.attachShader(arg1, arg2);
        },
        __wbg_bindBuffer_710a611286e86fe9: function(arg0, arg1, arg2) {
            arg0.bindBuffer(arg1 >>> 0, arg2);
        },
        __wbg_bindBuffer_b193f35215c88d5d: function(arg0, arg1, arg2) {
            arg0.bindBuffer(arg1 >>> 0, arg2);
        },
        __wbg_bindFramebuffer_8d7b9da43a5c1c2b: function(arg0, arg1, arg2) {
            arg0.bindFramebuffer(arg1 >>> 0, arg2);
        },
        __wbg_bindFramebuffer_fab857ccf69f3da9: function(arg0, arg1, arg2) {
            arg0.bindFramebuffer(arg1 >>> 0, arg2);
        },
        __wbg_bindRenderbuffer_21cf597fc94be1c7: function(arg0, arg1, arg2) {
            arg0.bindRenderbuffer(arg1 >>> 0, arg2);
        },
        __wbg_bindRenderbuffer_30a3bb44ea0e058f: function(arg0, arg1, arg2) {
            arg0.bindRenderbuffer(arg1 >>> 0, arg2);
        },
        __wbg_bindTexture_a87fb41b3319bcb9: function(arg0, arg1, arg2) {
            arg0.bindTexture(arg1 >>> 0, arg2);
        },
        __wbg_bindTexture_c3fcb7dc0c448083: function(arg0, arg1, arg2) {
            arg0.bindTexture(arg1 >>> 0, arg2);
        },
        __wbg_bindVertexArrayOES_b0e8a5a6c8a88c84: function(arg0, arg1) {
            arg0.bindVertexArrayOES(arg1);
        },
        __wbg_bindVertexArray_ea785b5f2238eb93: function(arg0, arg1) {
            arg0.bindVertexArray(arg1);
        },
        __wbg_blendEquationSeparate_1dedaa54091b78a5: function(arg0, arg1, arg2) {
            arg0.blendEquationSeparate(arg1 >>> 0, arg2 >>> 0);
        },
        __wbg_blendEquationSeparate_8a6f5cdd3d6af806: function(arg0, arg1, arg2) {
            arg0.blendEquationSeparate(arg1 >>> 0, arg2 >>> 0);
        },
        __wbg_blendFuncSeparate_a1f8e0d6a1fa6fa6: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.blendFuncSeparate(arg1 >>> 0, arg2 >>> 0, arg3 >>> 0, arg4 >>> 0);
        },
        __wbg_blendFuncSeparate_d3b4bffd37fd37de: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.blendFuncSeparate(arg1 >>> 0, arg2 >>> 0, arg3 >>> 0, arg4 >>> 0);
        },
        __wbg_blitFramebuffer_796256485239eebc: function(arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9, arg10) {
            arg0.blitFramebuffer(arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9 >>> 0, arg10 >>> 0);
        },
        __wbg_blur_583010b6b4026c5d: function() { return handleError(function (arg0) {
            arg0.blur();
        }, arguments); },
        __wbg_body_c7b35a55457167ba: function(arg0) {
            const ret = arg0.body;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_bottom_12dded5de5311aff: function(arg0) {
            const ret = arg0.bottom;
            return ret;
        },
        __wbg_bufferData_f267cdc80efbd6a0: function(arg0, arg1, arg2, arg3) {
            arg0.bufferData(arg1 >>> 0, arg2, arg3 >>> 0);
        },
        __wbg_bufferData_f401229c915b8028: function(arg0, arg1, arg2, arg3) {
            arg0.bufferData(arg1 >>> 0, arg2, arg3 >>> 0);
        },
        __wbg_button_c794bf4b1dcd7c4c: function(arg0) {
            const ret = arg0.button;
            return ret;
        },
        __wbg_call_14b169f759b26747: function() { return handleError(function (arg0, arg1) {
            const ret = arg0.call(arg1);
            return ret;
        }, arguments); },
        __wbg_call_86e39d65afc3d9db: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
            const ret = arg0.call(arg1, arg2, arg3, arg4);
            return ret;
        }, arguments); },
        __wbg_call_a24592a6f349a97e: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = arg0.call(arg1, arg2);
            return ret;
        }, arguments); },
        __wbg_call_bb28efe6b2f55b86: function() { return handleError(function (arg0, arg1, arg2, arg3) {
            const ret = arg0.call(arg1, arg2, arg3);
            return ret;
        }, arguments); },
        __wbg_cancelVideoFrameCallback_279c293308cb0614: function(arg0, arg1) {
            arg0.cancelVideoFrameCallback(arg1 >>> 0);
        },
        __wbg_clearColor_2b334a2a4b9f1124: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.clearColor(arg1, arg2, arg3, arg4);
        },
        __wbg_clearColor_6e92030afcf0f68f: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.clearColor(arg1, arg2, arg3, arg4);
        },
        __wbg_clearDepth_6a75b6bfa763b04c: function(arg0, arg1) {
            arg0.clearDepth(arg1);
        },
        __wbg_clearDepth_e602528ddc745c62: function(arg0, arg1) {
            arg0.clearDepth(arg1);
        },
        __wbg_clear_d82c0c485d1af30e: function(arg0, arg1) {
            arg0.clear(arg1 >>> 0);
        },
        __wbg_clear_e39cde04b063e709: function(arg0, arg1) {
            arg0.clear(arg1 >>> 0);
        },
        __wbg_clientHeight_01b31bebacb195f0: function(arg0) {
            const ret = arg0.clientHeight;
            return ret;
        },
        __wbg_clientX_48ead8c93aa7a872: function(arg0) {
            const ret = arg0.clientX;
            return ret;
        },
        __wbg_clientY_ddcce7762c925e13: function(arg0) {
            const ret = arg0.clientY;
            return ret;
        },
        __wbg_cloneNode_eb01fe238729dac4: function() { return handleError(function (arg0) {
            const ret = arg0.cloneNode();
            return ret;
        }, arguments); },
        __wbg_close_cc91f5b0a1697e4f: function() { return handleError(function (arg0) {
            const ret = arg0.close();
            return ret;
        }, arguments); },
        __wbg_code_09d0c59f9029dd28: function(arg0, arg1) {
            const ret = arg1.code;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_colorMask_5e1ce60e460bf963: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.colorMask(arg1 !== 0, arg2 !== 0, arg3 !== 0, arg4 !== 0);
        },
        __wbg_colorMask_71190391f59922fe: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.colorMask(arg1 !== 0, arg2 !== 0, arg3 !== 0, arg4 !== 0);
        },
        __wbg_compileShader_b39b7d5caca97c9d: function(arg0, arg1) {
            arg0.compileShader(arg1);
        },
        __wbg_compileShader_fc084de511370bc0: function(arg0, arg1) {
            arg0.compileShader(arg1);
        },
        __wbg_connect_301bfaee317657e7: function() { return handleError(function (arg0, arg1) {
            const ret = arg0.connect(arg1);
            return ret;
        }, arguments); },
        __wbg_createBuffer_6ad9886c8fed1a21: function(arg0) {
            const ret = arg0.createBuffer();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createBuffer_f68202a47c36c3d6: function(arg0) {
            const ret = arg0.createBuffer();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createElement_bbd4c90086fe6f7b: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = arg0.createElement(getStringFromWasm0(arg1, arg2));
            return ret;
        }, arguments); },
        __wbg_createFramebuffer_03fa5aab12587b89: function(arg0) {
            const ret = arg0.createFramebuffer();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createFramebuffer_211e9c2acecac22f: function(arg0) {
            const ret = arg0.createFramebuffer();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createGain_9f1346a2369109e0: function() { return handleError(function (arg0) {
            const ret = arg0.createGain();
            return ret;
        }, arguments); },
        __wbg_createMediaElementSource_0ede14d8847e4e21: function() { return handleError(function (arg0, arg1) {
            const ret = arg0.createMediaElementSource(arg1);
            return ret;
        }, arguments); },
        __wbg_createProgram_635f6f85c5f3c83d: function(arg0) {
            const ret = arg0.createProgram();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createProgram_bedc70c0d16e41df: function(arg0) {
            const ret = arg0.createProgram();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createRenderbuffer_35e6bde126d973f9: function(arg0) {
            const ret = arg0.createRenderbuffer();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createRenderbuffer_cb16d578fe2964c3: function(arg0) {
            const ret = arg0.createRenderbuffer();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createShader_2c8d8c9f17967efe: function(arg0, arg1) {
            const ret = arg0.createShader(arg1 >>> 0);
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createShader_5484e429d7514a9d: function(arg0, arg1) {
            const ret = arg0.createShader(arg1 >>> 0);
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createTexture_caeb4349ae5c7a83: function(arg0) {
            const ret = arg0.createTexture();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createTexture_f9850d55f04c7883: function(arg0) {
            const ret = arg0.createTexture();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createVertexArrayOES_25823ca742b59551: function(arg0) {
            const ret = arg0.createVertexArrayOES();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_createVertexArray_a8c3e6799bdb5af8: function(arg0) {
            const ret = arg0.createVertexArray();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_ctrlKey_31968cccd46bdef6: function(arg0) {
            const ret = arg0.ctrlKey;
            return ret;
        },
        __wbg_ctrlKey_a49693667722b909: function(arg0) {
            const ret = arg0.ctrlKey;
            return ret;
        },
        __wbg_cullFace_87cf8b47e8d3edd2: function(arg0, arg1) {
            arg0.cullFace(arg1 >>> 0);
        },
        __wbg_cullFace_c35bb54d07e68290: function(arg0, arg1) {
            arg0.cullFace(arg1 >>> 0);
        },
        __wbg_currentTime_8e9bfa251075a7d7: function(arg0) {
            const ret = arg0.currentTime;
            return ret;
        },
        __wbg_currentTime_ed6ce93e843d1f92: function(arg0) {
            const ret = arg0.currentTime;
            return ret;
        },
        __wbg_deleteBuffer_521c77539f9941c1: function(arg0, arg1) {
            arg0.deleteBuffer(arg1);
        },
        __wbg_deleteBuffer_558c85bd550b15df: function(arg0, arg1) {
            arg0.deleteBuffer(arg1);
        },
        __wbg_deleteFramebuffer_2fb61c893f34a853: function(arg0, arg1) {
            arg0.deleteFramebuffer(arg1);
        },
        __wbg_deleteFramebuffer_a0b3386cb631ca92: function(arg0, arg1) {
            arg0.deleteFramebuffer(arg1);
        },
        __wbg_deleteProgram_6d3a2bdf7fc6d658: function(arg0, arg1) {
            arg0.deleteProgram(arg1);
        },
        __wbg_deleteProgram_8175823e816f19ed: function(arg0, arg1) {
            arg0.deleteProgram(arg1);
        },
        __wbg_deleteRenderbuffer_826cb5d271ce4663: function(arg0, arg1) {
            arg0.deleteRenderbuffer(arg1);
        },
        __wbg_deleteRenderbuffer_fe0ab39c4929254b: function(arg0, arg1) {
            arg0.deleteRenderbuffer(arg1);
        },
        __wbg_deleteShader_379785984071d8af: function(arg0, arg1) {
            arg0.deleteShader(arg1);
        },
        __wbg_deleteShader_460e3d0b80ea3790: function(arg0, arg1) {
            arg0.deleteShader(arg1);
        },
        __wbg_deleteTexture_6de16581bf7e5e00: function(arg0, arg1) {
            arg0.deleteTexture(arg1);
        },
        __wbg_deleteTexture_8714aac647598458: function(arg0, arg1) {
            arg0.deleteTexture(arg1);
        },
        __wbg_deltaX_7f421a85054bc57c: function(arg0) {
            const ret = arg0.deltaX;
            return ret;
        },
        __wbg_deltaY_ca7744a8772482e1: function(arg0) {
            const ret = arg0.deltaY;
            return ret;
        },
        __wbg_depthFunc_2dcf4f6cd1ae352f: function(arg0, arg1) {
            arg0.depthFunc(arg1 >>> 0);
        },
        __wbg_depthFunc_477c738f0d31fb27: function(arg0, arg1) {
            arg0.depthFunc(arg1 >>> 0);
        },
        __wbg_depthMask_0212eafbadf5c510: function(arg0, arg1) {
            arg0.depthMask(arg1 !== 0);
        },
        __wbg_depthMask_79ce0d02cd6be571: function(arg0, arg1) {
            arg0.depthMask(arg1 !== 0);
        },
        __wbg_destination_7aa167ec1225162d: function(arg0) {
            const ret = arg0.destination;
            return ret;
        },
        __wbg_detachShader_06989c5755718519: function(arg0, arg1, arg2) {
            arg0.detachShader(arg1, arg2);
        },
        __wbg_detachShader_870ea94233e1f480: function(arg0, arg1, arg2) {
            arg0.detachShader(arg1, arg2);
        },
        __wbg_devicePixelRatio_18e6533e6d7f4088: function(arg0) {
            const ret = arg0.devicePixelRatio;
            return ret;
        },
        __wbg_disableVertexAttribArray_c56221197975648d: function(arg0, arg1) {
            arg0.disableVertexAttribArray(arg1 >>> 0);
        },
        __wbg_disableVertexAttribArray_dbf84d5ba8f67bad: function(arg0, arg1) {
            arg0.disableVertexAttribArray(arg1 >>> 0);
        },
        __wbg_disable_c83e7f9d8a8660e6: function(arg0, arg1) {
            arg0.disable(arg1 >>> 0);
        },
        __wbg_disable_d115c77f70b6b789: function(arg0, arg1) {
            arg0.disable(arg1 >>> 0);
        },
        __wbg_disconnect_934519920fb8dbf0: function() { return handleError(function (arg0) {
            arg0.disconnect();
        }, arguments); },
        __wbg_document_7a41071f2f439323: function(arg0) {
            const ret = arg0.document;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_done_9158f7cc8751ba32: function(arg0) {
            const ret = arg0.done;
            return ret;
        },
        __wbg_drawArraysInstancedANGLE_f6a18e87c8a056c3: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.drawArraysInstancedANGLE(arg1 >>> 0, arg2, arg3, arg4);
        },
        __wbg_drawArraysInstanced_43319f9817fad285: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.drawArraysInstanced(arg1 >>> 0, arg2, arg3, arg4);
        },
        __wbg_drawArrays_058a7d3434327b6d: function(arg0, arg1, arg2, arg3) {
            arg0.drawArrays(arg1 >>> 0, arg2, arg3);
        },
        __wbg_drawArrays_0b6495544ecb3b5e: function(arg0, arg1, arg2, arg3) {
            arg0.drawArrays(arg1 >>> 0, arg2, arg3);
        },
        __wbg_drawBuffersWEBGL_674a96484245cee8: function(arg0, arg1) {
            arg0.drawBuffersWEBGL(arg1);
        },
        __wbg_drawBuffers_0808a2009fb32b11: function(arg0, arg1) {
            arg0.drawBuffers(arg1);
        },
        __wbg_drawElementsInstancedANGLE_01b7fe3dcfda1f57: function(arg0, arg1, arg2, arg3, arg4, arg5) {
            arg0.drawElementsInstancedANGLE(arg1 >>> 0, arg2, arg3 >>> 0, arg4, arg5);
        },
        __wbg_drawElementsInstanced_9cdd75777f6fe52e: function(arg0, arg1, arg2, arg3, arg4, arg5) {
            arg0.drawElementsInstanced(arg1 >>> 0, arg2, arg3 >>> 0, arg4, arg5);
        },
        __wbg_drawElements_46de48663337d73d: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.drawElements(arg1 >>> 0, arg2, arg3 >>> 0, arg4);
        },
        __wbg_drawElements_fd9adcd1cc7deb47: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.drawElements(arg1 >>> 0, arg2, arg3 >>> 0, arg4);
        },
        __wbg_drawImage_7b56907fbfb3137d: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5) {
            arg0.drawImage(arg1, arg2, arg3, arg4, arg5);
        }, arguments); },
        __wbg_duration_dff62afc73b8479d: function(arg0) {
            const ret = arg0.duration;
            return ret;
        },
        __wbg_enableVertexAttribArray_44d2f9d5bd7d4773: function(arg0, arg1) {
            arg0.enableVertexAttribArray(arg1 >>> 0);
        },
        __wbg_enableVertexAttribArray_a6fb4500c619f67f: function(arg0, arg1) {
            arg0.enableVertexAttribArray(arg1 >>> 0);
        },
        __wbg_enable_aafffd647725f82c: function(arg0, arg1) {
            arg0.enable(arg1 >>> 0);
        },
        __wbg_enable_e9e223bf04c318ac: function(arg0, arg1) {
            arg0.enable(arg1 >>> 0);
        },
        __wbg_entries_e0b73aa8571ddb56: function(arg0) {
            const ret = Object.entries(arg0);
            return ret;
        },
        __wbg_focus_089295847acbfa20: function() { return handleError(function (arg0) {
            arg0.focus();
        }, arguments); },
        __wbg_framebufferRenderbuffer_45ca809f8ae492b2: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.framebufferRenderbuffer(arg1 >>> 0, arg2 >>> 0, arg3 >>> 0, arg4);
        },
        __wbg_framebufferRenderbuffer_fb45867659c40998: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.framebufferRenderbuffer(arg1 >>> 0, arg2 >>> 0, arg3 >>> 0, arg4);
        },
        __wbg_framebufferTexture2D_44e56e9e14542bb5: function(arg0, arg1, arg2, arg3, arg4, arg5) {
            arg0.framebufferTexture2D(arg1 >>> 0, arg2 >>> 0, arg3 >>> 0, arg4, arg5);
        },
        __wbg_framebufferTexture2D_f54db6e0dc9fac5e: function(arg0, arg1, arg2, arg3, arg4, arg5) {
            arg0.framebufferTexture2D(arg1 >>> 0, arg2 >>> 0, arg3 >>> 0, arg4, arg5);
        },
        __wbg_framebufferTextureLayer_9304ec957d83d40c: function(arg0, arg1, arg2, arg3, arg4, arg5) {
            arg0.framebufferTextureLayer(arg1 >>> 0, arg2 >>> 0, arg3, arg4, arg5);
        },
        __wbg_gain_af09f4ecb5d66a4e: function(arg0) {
            const ret = arg0.gain;
            return ret;
        },
        __wbg_generateMipmap_63267ff3c3360718: function(arg0, arg1) {
            arg0.generateMipmap(arg1 >>> 0);
        },
        __wbg_generateMipmap_e3c8922f41acbaa3: function(arg0, arg1) {
            arg0.generateMipmap(arg1 >>> 0);
        },
        __wbg_getActiveAttrib_1537b85f20ef0e93: function(arg0, arg1, arg2) {
            const ret = arg0.getActiveAttrib(arg1, arg2 >>> 0);
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_getActiveAttrib_f35788369c88a822: function(arg0, arg1, arg2) {
            const ret = arg0.getActiveAttrib(arg1, arg2 >>> 0);
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_getActiveUniform_a4b07e75970daa53: function(arg0, arg1, arg2) {
            const ret = arg0.getActiveUniform(arg1, arg2 >>> 0);
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_getActiveUniform_f9ae35d017702b1c: function(arg0, arg1, arg2) {
            const ret = arg0.getActiveUniform(arg1, arg2 >>> 0);
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_getAttribLocation_90d88542c4d9abb8: function(arg0, arg1, arg2, arg3) {
            const ret = arg0.getAttribLocation(arg1, getStringFromWasm0(arg2, arg3));
            return ret;
        },
        __wbg_getAttribLocation_f3c02085330a64e8: function(arg0, arg1, arg2, arg3) {
            const ret = arg0.getAttribLocation(arg1, getStringFromWasm0(arg2, arg3));
            return ret;
        },
        __wbg_getAttribute_8627dea35cdb7b06: function(arg0, arg1, arg2, arg3) {
            const ret = arg1.getAttribute(getStringFromWasm0(arg2, arg3));
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_getBoundingClientRect_ddac06b2c6b52b98: function(arg0) {
            const ret = arg0.getBoundingClientRect();
            return ret;
        },
        __wbg_getContext_367a8d870ace1970: function() { return handleError(function (arg0, arg1, arg2, arg3) {
            const ret = arg0.getContext(getStringFromWasm0(arg1, arg2), arg3);
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        }, arguments); },
        __wbg_getContext_fc146f8ec021d074: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = arg0.getContext(getStringFromWasm0(arg1, arg2));
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        }, arguments); },
        __wbg_getExtension_5228364a0715c7db: function() { return handleError(function (arg0, arg1, arg2) {
            const ret = arg0.getExtension(getStringFromWasm0(arg1, arg2));
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        }, arguments); },
        __wbg_getParameter_594f21b1d26abeed: function() { return handleError(function (arg0, arg1) {
            const ret = arg0.getParameter(arg1 >>> 0);
            return ret;
        }, arguments); },
        __wbg_getParameter_e1c6e394a2959d43: function() { return handleError(function (arg0, arg1) {
            const ret = arg0.getParameter(arg1 >>> 0);
            return ret;
        }, arguments); },
        __wbg_getProgramInfoLog_00af0d3e29c73293: function(arg0, arg1, arg2) {
            const ret = arg1.getProgramInfoLog(arg2);
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_getProgramInfoLog_612d2724e854e752: function(arg0, arg1, arg2) {
            const ret = arg1.getProgramInfoLog(arg2);
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_getProgramParameter_6aa39c38709e0d9d: function(arg0, arg1, arg2) {
            const ret = arg0.getProgramParameter(arg1, arg2 >>> 0);
            return ret;
        },
        __wbg_getProgramParameter_d18275e84d037799: function(arg0, arg1, arg2) {
            const ret = arg0.getProgramParameter(arg1, arg2 >>> 0);
            return ret;
        },
        __wbg_getShaderInfoLog_57fd85336a768aa9: function(arg0, arg1, arg2) {
            const ret = arg1.getShaderInfoLog(arg2);
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_getShaderInfoLog_ef603aa10b52d639: function(arg0, arg1, arg2) {
            const ret = arg1.getShaderInfoLog(arg2);
            var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_getSupportedExtensions_a6b7a4d43810c644: function(arg0) {
            const ret = arg0.getSupportedExtensions();
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_getUniformLocation_084155a4348002df: function(arg0, arg1, arg2, arg3) {
            const ret = arg0.getUniformLocation(arg1, getStringFromWasm0(arg2, arg3));
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_getUniformLocation_91e9e13f695e50c5: function(arg0, arg1, arg2, arg3) {
            const ret = arg0.getUniformLocation(arg1, getStringFromWasm0(arg2, arg3));
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_get_1affdbdd5573b16a: function() { return handleError(function (arg0, arg1) {
            const ret = Reflect.get(arg0, arg1);
            return ret;
        }, arguments); },
        __wbg_get_8360291721e2339f: function(arg0, arg1) {
            const ret = arg0[arg1 >>> 0];
            return ret;
        },
        __wbg_get_unchecked_17f53dad852b9588: function(arg0, arg1) {
            const ret = arg0[arg1 >>> 0];
            return ret;
        },
        __wbg_get_with_ref_key_6412cf3094599694: function(arg0, arg1) {
            const ret = arg0[arg1];
            return ret;
        },
        __wbg_height_528848d067cc2221: function(arg0) {
            const ret = arg0.height;
            return ret;
        },
        __wbg_height_cc0f4b9ec7073c11: function(arg0) {
            const ret = arg0.height;
            return ret;
        },
        __wbg_height_e9bd2453b0432ed7: function(arg0) {
            const ret = arg0.height;
            return ret;
        },
        __wbg_innerHeight_72e7bb88c4b9ede8: function() { return handleError(function (arg0) {
            const ret = arg0.innerHeight;
            return ret;
        }, arguments); },
        __wbg_innerWidth_c7446907ab672e41: function() { return handleError(function (arg0) {
            const ret = arg0.innerWidth;
            return ret;
        }, arguments); },
        __wbg_instanceof_ArrayBuffer_7c8433c6ed14ffe3: function(arg0) {
            let result;
            try {
                result = arg0 instanceof ArrayBuffer;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_CanvasRenderingContext2d_24a3fe06e62b98d7: function(arg0) {
            let result;
            try {
                result = arg0 instanceof CanvasRenderingContext2D;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_HtmlCanvasElement_ea4dfc3bb77c734b: function(arg0) {
            let result;
            try {
                result = arg0 instanceof HTMLCanvasElement;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_HtmlTextAreaElement_73ab48e7517a68c2: function(arg0) {
            let result;
            try {
                result = arg0 instanceof HTMLTextAreaElement;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Map_1b76fd4635be43eb: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Map;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Uint8Array_152ba1f289edcf3f: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Uint8Array;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_WebGl2RenderingContext_23f2da2f294d4c8e: function(arg0) {
            let result;
            try {
                result = arg0 instanceof WebGL2RenderingContext;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_instanceof_Window_cc64c86c8ef9e02b: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Window;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_isArray_c3109d14ffc06469: function(arg0) {
            const ret = Array.isArray(arg0);
            return ret;
        },
        __wbg_isSafeInteger_4fc213d1989d6d2a: function(arg0) {
            const ret = Number.isSafeInteger(arg0);
            return ret;
        },
        __wbg_is_8f7ba86b7f249abd: function(arg0, arg1) {
            const ret = Object.is(arg0, arg1);
            return ret;
        },
        __wbg_iterator_013bc09ec998c2a7: function() {
            const ret = Symbol.iterator;
            return ret;
        },
        __wbg_key_2cbc38fa83cdb336: function(arg0, arg1) {
            const ret = arg1.key;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_left_ea423c913972748d: function(arg0) {
            const ret = arg0.left;
            return ret;
        },
        __wbg_length_3d4ecd04bd8d22f1: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_length_9f1775224cf1d815: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_linkProgram_0f095b446d393a30: function(arg0, arg1) {
            arg0.linkProgram(arg1);
        },
        __wbg_linkProgram_aa5b01ff0fcf3a80: function(arg0, arg1) {
            arg0.linkProgram(arg1);
        },
        __wbg_load_b97e7d9197088676: function(arg0) {
            arg0.load();
        },
        __wbg_metaKey_665498d01ebfd062: function(arg0) {
            const ret = arg0.metaKey;
            return ret;
        },
        __wbg_metaKey_f8f3c1d2a5b88850: function(arg0) {
            const ret = arg0.metaKey;
            return ret;
        },
        __wbg_muted_6b976195a81452c2: function(arg0) {
            const ret = arg0.muted;
            return ret;
        },
        __wbg_name_01977c9e324b45c0: function(arg0, arg1) {
            const ret = arg1.name;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_navigator_bc077756492232c5: function(arg0) {
            const ret = arg0.navigator;
            return ret;
        },
        __wbg_new_0c7403db6e782f19: function(arg0) {
            const ret = new Uint8Array(arg0);
            return ret;
        },
        __wbg_new_34d45cc8e36aaead: function() {
            const ret = new Map();
            return ret;
        },
        __wbg_new_3d402464d6294d33: function() {
            const ret = new Error();
            return ret;
        },
        __wbg_new_682678e2f47e32bc: function() {
            const ret = new Array();
            return ret;
        },
        __wbg_new_aa8d0fa9762c29bd: function() {
            const ret = new Object();
            return ret;
        },
        __wbg_new_df431d05bd05ed26: function() { return handleError(function () {
            const ret = new lAudioContext();
            return ret;
        }, arguments); },
        __wbg_next_0340c4ae324393c3: function() { return handleError(function (arg0) {
            const ret = arg0.next();
            return ret;
        }, arguments); },
        __wbg_next_7646edaa39458ef7: function(arg0) {
            const ret = arg0.next;
            return ret;
        },
        __wbg_now_e7c6795a7f81e10f: function(arg0) {
            const ret = arg0.now();
            return ret;
        },
        __wbg_of_07054ba808010e4f: function(arg0) {
            const ret = Array.of(arg0);
            return ret;
        },
        __wbg_offsetHeight_1e906c4f333e7e62: function(arg0) {
            const ret = arg0.offsetHeight;
            return ret;
        },
        __wbg_offsetWidth_c28e4e947f89201d: function(arg0) {
            const ret = arg0.offsetWidth;
            return ret;
        },
        __wbg_offsetX_a88ab66c480b77a3: function(arg0) {
            const ret = arg0.offsetX;
            return ret;
        },
        __wbg_offsetY_679a899b0b60c036: function(arg0) {
            const ret = arg0.offsetY;
            return ret;
        },
        __wbg_pause_4d31251d7f5adac1: function() { return handleError(function (arg0) {
            arg0.pause();
        }, arguments); },
        __wbg_paused_2c6bb20bdf8be8f8: function(arg0) {
            const ret = arg0.paused;
            return ret;
        },
        __wbg_performance_3fcf6e32a7e1ed0a: function(arg0) {
            const ret = arg0.performance;
            return ret;
        },
        __wbg_pixelStorei_0da594e7ec84d2ef: function(arg0, arg1, arg2) {
            arg0.pixelStorei(arg1 >>> 0, arg2);
        },
        __wbg_pixelStorei_6f7ca5f58231a418: function(arg0, arg1, arg2) {
            arg0.pixelStorei(arg1 >>> 0, arg2);
        },
        __wbg_platform_51b578a506978b1e: function() { return handleError(function (arg0, arg1) {
            const ret = arg1.platform;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        }, arguments); },
        __wbg_play_c4046eb80d8ddda8: function() { return handleError(function (arg0) {
            const ret = arg0.play();
            return ret;
        }, arguments); },
        __wbg_playbackRate_4143eb2403084317: function(arg0) {
            const ret = arg0.playbackRate;
            return ret;
        },
        __wbg_prototypesetcall_a6b02eb00b0f4ce2: function(arg0, arg1, arg2) {
            Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), arg2);
        },
        __wbg_push_471a5b068a5295f6: function(arg0, arg1) {
            const ret = arg0.push(arg1);
            return ret;
        },
        __wbg_readPixels_a78444c3ffa2ad18: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
            arg0.readPixels(arg1, arg2, arg3, arg4, arg5 >>> 0, arg6 >>> 0, arg7);
        }, arguments); },
        __wbg_readPixels_bfac0d542650a07a: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
            arg0.readPixels(arg1, arg2, arg3, arg4, arg5 >>> 0, arg6 >>> 0, arg7);
        }, arguments); },
        __wbg_readPixels_dd7e621f7a36e2ac: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
            arg0.readPixels(arg1, arg2, arg3, arg4, arg5 >>> 0, arg6 >>> 0, arg7);
        }, arguments); },
        __wbg_readyState_44b1c242bae6d5e1: function(arg0) {
            const ret = arg0.readyState;
            return ret;
        },
        __wbg_removeEventListener_7bdf07404d9b24bd: function() { return handleError(function (arg0, arg1, arg2, arg3) {
            arg0.removeEventListener(getStringFromWasm0(arg1, arg2), arg3);
        }, arguments); },
        __wbg_remove_48cb93cf7a6c4260: function(arg0) {
            arg0.remove();
        },
        __wbg_renderbufferStorageMultisample_363ea6ea6644c47f: function(arg0, arg1, arg2, arg3, arg4, arg5) {
            arg0.renderbufferStorageMultisample(arg1 >>> 0, arg2, arg3 >>> 0, arg4, arg5);
        },
        __wbg_requestVideoFrameCallback_2242008a61600226: function(arg0, arg1) {
            const ret = arg0.requestVideoFrameCallback(arg1);
            return ret;
        },
        __wbg_requestVideoFrameCallback_2d56d81bd5909e8f: function(arg0) {
            const ret = arg0.requestVideoFrameCallback;
            return ret;
        },
        __wbg_resume_b12ef3046a46b3f7: function() { return handleError(function (arg0) {
            const ret = arg0.resume();
            return ret;
        }, arguments); },
        __wbg_right_6096346a1fca4d04: function(arg0) {
            const ret = arg0.right;
            return ret;
        },
        __wbg_scissor_a52de5e62ebadc16: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.scissor(arg1, arg2, arg3, arg4);
        },
        __wbg_scissor_b71fb7e05633cf3d: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.scissor(arg1, arg2, arg3, arg4);
        },
        __wbg_seeking_f44483783704dc70: function(arg0) {
            const ret = arg0.seeking;
            return ret;
        },
        __wbg_selectionEnd_f3cf63152d5cfed2: function() { return handleError(function (arg0) {
            const ret = arg0.selectionEnd;
            return isLikeNone(ret) ? 0x100000001 : (ret) >>> 0;
        }, arguments); },
        __wbg_selectionStart_3e81af07f9b629e2: function() { return handleError(function (arg0) {
            const ret = arg0.selectionStart;
            return isLikeNone(ret) ? 0x100000001 : (ret) >>> 0;
        }, arguments); },
        __wbg_setAttribute_6fde4098d274155c: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
            arg0.setAttribute(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
        }, arguments); },
        __wbg_setProperty_0d903d23a71dfe70: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
            arg0.setProperty(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
        }, arguments); },
        __wbg_setTargetAtTime_0c5c645a33f79a5a: function() { return handleError(function (arg0, arg1, arg2, arg3) {
            const ret = arg0.setTargetAtTime(arg1, arg2, arg3);
            return ret;
        }, arguments); },
        __wbg_set_3bf1de9fab0cd644: function(arg0, arg1, arg2) {
            arg0[arg1 >>> 0] = arg2;
        },
        __wbg_set_6be42768c690e380: function(arg0, arg1, arg2) {
            arg0[arg1] = arg2;
        },
        __wbg_set_currentTime_8dff14aaffa6af0b: function(arg0, arg1) {
            arg0.currentTime = arg1;
        },
        __wbg_set_fde2cec06c23692b: function(arg0, arg1, arg2) {
            const ret = arg0.set(arg1, arg2);
            return ret;
        },
        __wbg_set_height_be9b2b920bd68401: function(arg0, arg1) {
            arg0.height = arg1 >>> 0;
        },
        __wbg_set_muted_f47a79cb62c8af4d: function(arg0, arg1) {
            arg0.muted = arg1 !== 0;
        },
        __wbg_set_playbackRate_5f8bee9032180e50: function(arg0, arg1) {
            arg0.playbackRate = arg1;
        },
        __wbg_set_selectionEnd_0b7cd674d4e9ff5a: function() { return handleError(function (arg0, arg1) {
            arg0.selectionEnd = arg1 === 0x100000001 ? undefined : arg1;
        }, arguments); },
        __wbg_set_selectionStart_a388e849b7b20576: function() { return handleError(function (arg0, arg1) {
            arg0.selectionStart = arg1 === 0x100000001 ? undefined : arg1;
        }, arguments); },
        __wbg_set_src_131d0c69b284b037: function(arg0, arg1, arg2) {
            arg0.src = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_value_701931da23e8bae7: function(arg0, arg1) {
            arg0.value = arg1;
        },
        __wbg_set_value_d3cd5a0ce61506cd: function(arg0, arg1, arg2) {
            arg0.value = getStringFromWasm0(arg1, arg2);
        },
        __wbg_set_volume_1741406a2f0b0ce9: function(arg0, arg1) {
            arg0.volume = arg1;
        },
        __wbg_set_width_5cda41d4d06a14dd: function(arg0, arg1) {
            arg0.width = arg1 >>> 0;
        },
        __wbg_shaderSource_084cd6ed337b36be: function(arg0, arg1, arg2, arg3) {
            arg0.shaderSource(arg1, getStringFromWasm0(arg2, arg3));
        },
        __wbg_shaderSource_9b5906e1f027a314: function(arg0, arg1, arg2, arg3) {
            arg0.shaderSource(arg1, getStringFromWasm0(arg2, arg3));
        },
        __wbg_shiftKey_dcf8ee699c273ed2: function(arg0) {
            const ret = arg0.shiftKey;
            return ret;
        },
        __wbg_shiftKey_e483c13c966878f6: function(arg0) {
            const ret = arg0.shiftKey;
            return ret;
        },
        __wbg_size_3de9227138efa947: function(arg0) {
            const ret = arg0.size;
            return ret;
        },
        __wbg_stack_b35e9a6d95beeaf7: function(arg0, arg1) {
            const ret = arg1.stack;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_static_accessor_GLOBAL_8cfadc87a297ca02: function() {
            const ret = typeof global === 'undefined' ? null : global;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_static_accessor_GLOBAL_THIS_602256ae5c8f42cf: function() {
            const ret = typeof globalThis === 'undefined' ? null : globalThis;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_static_accessor_SELF_e445c1c7484aecc3: function() {
            const ret = typeof self === 'undefined' ? null : self;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_static_accessor_WINDOW_f20e8576ef1e0f17: function() {
            const ret = typeof window === 'undefined' ? null : window;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_style_c331a9f6564f8f62: function(arg0) {
            const ret = arg0.style;
            return ret;
        },
        __wbg_target_6d97e221d11b71b6: function(arg0) {
            const ret = arg0.target;
            return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
        },
        __wbg_texImage2D_0076e78f4309339c: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
            arg0.texImage2D(arg1 >>> 0, arg2, arg3, arg4 >>> 0, arg5 >>> 0, arg6);
        }, arguments); },
        __wbg_texImage2D_044115ac2a49e10a: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
            arg0.texImage2D(arg1 >>> 0, arg2, arg3, arg4 >>> 0, arg5 >>> 0, arg6);
        }, arguments); },
        __wbg_texImage2D_5df82d53088dd70a: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
            arg0.texImage2D(arg1 >>> 0, arg2, arg3, arg4 >>> 0, arg5 >>> 0, arg6);
        }, arguments); },
        __wbg_texImage2D_a6d9e50bec5b1777: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
            arg0.texImage2D(arg1 >>> 0, arg2, arg3, arg4 >>> 0, arg5 >>> 0, arg6);
        }, arguments); },
        __wbg_texImage2D_b17c7723201a6d5e: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9) {
            arg0.texImage2D(arg1 >>> 0, arg2, arg3, arg4, arg5, arg6, arg7 >>> 0, arg8 >>> 0, arg9);
        }, arguments); },
        __wbg_texImage2D_bd0466091ed50f83: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9) {
            arg0.texImage2D(arg1 >>> 0, arg2, arg3, arg4, arg5, arg6, arg7 >>> 0, arg8 >>> 0, arg9);
        }, arguments); },
        __wbg_texImage2D_f110542c571d15a4: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9) {
            arg0.texImage2D(arg1 >>> 0, arg2, arg3, arg4, arg5, arg6, arg7 >>> 0, arg8 >>> 0, arg9);
        }, arguments); },
        __wbg_texParameteri_83c7801427720baa: function(arg0, arg1, arg2, arg3) {
            arg0.texParameteri(arg1 >>> 0, arg2 >>> 0, arg3);
        },
        __wbg_texParameteri_bc24667dff936ebd: function(arg0, arg1, arg2, arg3) {
            arg0.texParameteri(arg1 >>> 0, arg2 >>> 0, arg3);
        },
        __wbg_texStorage2D_cd0049448f436f56: function(arg0, arg1, arg2, arg3, arg4, arg5) {
            arg0.texStorage2D(arg1 >>> 0, arg2, arg3 >>> 0, arg4, arg5);
        },
        __wbg_texSubImage2D_5d41ae5586dadcb3: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9) {
            arg0.texSubImage2D(arg1 >>> 0, arg2, arg3, arg4, arg5, arg6, arg7 >>> 0, arg8 >>> 0, arg9);
        }, arguments); },
        __wbg_texSubImage2D_7e472dfbf112e954: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9) {
            arg0.texSubImage2D(arg1 >>> 0, arg2, arg3, arg4, arg5, arg6, arg7 >>> 0, arg8 >>> 0, arg9);
        }, arguments); },
        __wbg_texSubImage2D_9c0f642762c6c35b: function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9) {
            arg0.texSubImage2D(arg1 >>> 0, arg2, arg3, arg4, arg5, arg6, arg7 >>> 0, arg8 >>> 0, arg9);
        }, arguments); },
        __wbg_top_158f7c4dd1427771: function(arg0) {
            const ret = arg0.top;
            return ret;
        },
        __wbg_type_ce8d0b86145cd86f: function(arg0) {
            const ret = arg0.type;
            return ret;
        },
        __wbg_uniform1fv_02509be8ad6fe7cf: function(arg0, arg1, arg2, arg3) {
            arg0.uniform1fv(arg1, getArrayF32FromWasm0(arg2, arg3));
        },
        __wbg_uniform1fv_10fe17afab64f39a: function(arg0, arg1, arg2, arg3) {
            arg0.uniform1fv(arg1, getArrayF32FromWasm0(arg2, arg3));
        },
        __wbg_uniform1iv_a8af21b8373d65ff: function(arg0, arg1, arg2, arg3) {
            arg0.uniform1iv(arg1, getArrayI32FromWasm0(arg2, arg3));
        },
        __wbg_uniform1iv_eaeb178159d5067b: function(arg0, arg1, arg2, arg3) {
            arg0.uniform1iv(arg1, getArrayI32FromWasm0(arg2, arg3));
        },
        __wbg_uniform1uiv_b2698fdb7189339f: function(arg0, arg1, arg2, arg3) {
            arg0.uniform1uiv(arg1, getArrayU32FromWasm0(arg2, arg3));
        },
        __wbg_uniform2fv_0cc1bfc11f911dda: function(arg0, arg1, arg2, arg3) {
            arg0.uniform2fv(arg1, getArrayF32FromWasm0(arg2, arg3));
        },
        __wbg_uniform2fv_811d97ec656282f5: function(arg0, arg1, arg2, arg3) {
            arg0.uniform2fv(arg1, getArrayF32FromWasm0(arg2, arg3));
        },
        __wbg_uniform3fv_8aba848c825c4dcc: function(arg0, arg1, arg2, arg3) {
            arg0.uniform3fv(arg1, getArrayF32FromWasm0(arg2, arg3));
        },
        __wbg_uniform3fv_ff2fddc612532e5f: function(arg0, arg1, arg2, arg3) {
            arg0.uniform3fv(arg1, getArrayF32FromWasm0(arg2, arg3));
        },
        __wbg_uniform4fv_68ac9dbef7f9bdf8: function(arg0, arg1, arg2, arg3) {
            arg0.uniform4fv(arg1, getArrayF32FromWasm0(arg2, arg3));
        },
        __wbg_uniform4fv_7376535df870aea3: function(arg0, arg1, arg2, arg3) {
            arg0.uniform4fv(arg1, getArrayF32FromWasm0(arg2, arg3));
        },
        __wbg_uniformMatrix2fv_16670171c53575fa: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.uniformMatrix2fv(arg1, arg2 !== 0, getArrayF32FromWasm0(arg3, arg4));
        },
        __wbg_uniformMatrix2fv_cc942086aed65fce: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.uniformMatrix2fv(arg1, arg2 !== 0, getArrayF32FromWasm0(arg3, arg4));
        },
        __wbg_uniformMatrix3fv_677ba74bf760a105: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.uniformMatrix3fv(arg1, arg2 !== 0, getArrayF32FromWasm0(arg3, arg4));
        },
        __wbg_uniformMatrix3fv_d36ebef53bf8ae93: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.uniformMatrix3fv(arg1, arg2 !== 0, getArrayF32FromWasm0(arg3, arg4));
        },
        __wbg_uniformMatrix4fv_65df27ae81aac4a7: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.uniformMatrix4fv(arg1, arg2 !== 0, getArrayF32FromWasm0(arg3, arg4));
        },
        __wbg_uniformMatrix4fv_ad33dd8ac90a1166: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.uniformMatrix4fv(arg1, arg2 !== 0, getArrayF32FromWasm0(arg3, arg4));
        },
        __wbg_useProgram_6403314e6307ff8f: function(arg0, arg1) {
            arg0.useProgram(arg1);
        },
        __wbg_useProgram_b0607e62e147410b: function(arg0, arg1) {
            arg0.useProgram(arg1);
        },
        __wbg_value_acdc3fed0dd155ba: function(arg0, arg1) {
            const ret = arg1.value;
            const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
            getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
        },
        __wbg_value_ee3a06f4579184fa: function(arg0) {
            const ret = arg0.value;
            return ret;
        },
        __wbg_vertexAttribDivisorANGLE_49500429f99e1d27: function(arg0, arg1, arg2) {
            arg0.vertexAttribDivisorANGLE(arg1 >>> 0, arg2 >>> 0);
        },
        __wbg_vertexAttribDivisor_406c4f2dab66050b: function(arg0, arg1, arg2) {
            arg0.vertexAttribDivisor(arg1 >>> 0, arg2 >>> 0);
        },
        __wbg_vertexAttribIPointer_a64fdd378b987c16: function(arg0, arg1, arg2, arg3, arg4, arg5) {
            arg0.vertexAttribIPointer(arg1 >>> 0, arg2, arg3 >>> 0, arg4, arg5);
        },
        __wbg_vertexAttribPointer_89754c61239e5837: function(arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
            arg0.vertexAttribPointer(arg1 >>> 0, arg2, arg3 >>> 0, arg4 !== 0, arg5, arg6);
        },
        __wbg_vertexAttribPointer_dfec25e05e323ba4: function(arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
            arg0.vertexAttribPointer(arg1 >>> 0, arg2, arg3 >>> 0, arg4 !== 0, arg5, arg6);
        },
        __wbg_videoHeight_c6473e0876716097: function(arg0) {
            const ret = arg0.videoHeight;
            return ret;
        },
        __wbg_videoWidth_e8cbf52940ff039d: function(arg0) {
            const ret = arg0.videoWidth;
            return ret;
        },
        __wbg_viewport_325ef6f6b074c24f: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.viewport(arg1, arg2, arg3, arg4);
        },
        __wbg_viewport_b1858453ab05f289: function(arg0, arg1, arg2, arg3, arg4) {
            arg0.viewport(arg1, arg2, arg3, arg4);
        },
        __wbg_volume_5b42e6078d69c6d6: function(arg0) {
            const ret = arg0.volume;
            return ret;
        },
        __wbg_width_0b85c08524c203ea: function(arg0) {
            const ret = arg0.width;
            return ret;
        },
        __wbg_width_5adcb07d04d08bdf: function(arg0) {
            const ret = arg0.width;
            return ret;
        },
        __wbg_width_9673a519d7bd5a6a: function(arg0) {
            const ret = arg0.width;
            return ret;
        },
        __wbindgen_cast_0000000000000001: function(arg0, arg1) {
            // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [NamedExternref("KeyboardEvent")], shim_idx: 2380, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
            const ret = makeMutClosure(arg0, arg1, wasm_bindgen_642d14a50fc440ff___convert__closures_____invoke___web_sys_13772816b5501337___features__gen_FocusEvent__FocusEvent______true_);
            return ret;
        },
        __wbindgen_cast_0000000000000002: function(arg0, arg1) {
            // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [], shim_idx: 1388, ret: Unit, inner_ret: Some(Unit) }, mutable: false }) -> Externref`.
            const ret = makeClosure(arg0, arg1, wasm_bindgen_642d14a50fc440ff___convert__closures_____invoke_______true_);
            return ret;
        },
        __wbindgen_cast_0000000000000003: function(arg0, arg1) {
            // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [], shim_idx: 2382, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
            const ret = makeMutClosure(arg0, arg1, wasm_bindgen_642d14a50fc440ff___convert__closures_____invoke_______true__1_);
            return ret;
        },
        __wbindgen_cast_0000000000000004: function(arg0) {
            // Cast intrinsic for `F64 -> Externref`.
            const ret = arg0;
            return ret;
        },
        __wbindgen_cast_0000000000000005: function(arg0) {
            // Cast intrinsic for `I64 -> Externref`.
            const ret = arg0;
            return ret;
        },
        __wbindgen_cast_0000000000000006: function(arg0, arg1) {
            // Cast intrinsic for `Ref(Slice(F32)) -> NamedExternref("Float32Array")`.
            const ret = getArrayF32FromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_cast_0000000000000007: function(arg0, arg1) {
            // Cast intrinsic for `Ref(Slice(I16)) -> NamedExternref("Int16Array")`.
            const ret = getArrayI16FromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_cast_0000000000000008: function(arg0, arg1) {
            // Cast intrinsic for `Ref(Slice(I32)) -> NamedExternref("Int32Array")`.
            const ret = getArrayI32FromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_cast_0000000000000009: function(arg0, arg1) {
            // Cast intrinsic for `Ref(Slice(I8)) -> NamedExternref("Int8Array")`.
            const ret = getArrayI8FromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_cast_000000000000000a: function(arg0, arg1) {
            // Cast intrinsic for `Ref(Slice(U16)) -> NamedExternref("Uint16Array")`.
            const ret = getArrayU16FromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_cast_000000000000000b: function(arg0, arg1) {
            // Cast intrinsic for `Ref(Slice(U32)) -> NamedExternref("Uint32Array")`.
            const ret = getArrayU32FromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_cast_000000000000000c: function(arg0, arg1) {
            // Cast intrinsic for `Ref(Slice(U8)) -> NamedExternref("Uint8Array")`.
            const ret = getArrayU8FromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_cast_000000000000000d: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = getStringFromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_cast_000000000000000e: function(arg0) {
            // Cast intrinsic for `U64 -> Externref`.
            const ret = BigInt.asUintN(64, arg0);
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        },
    };
    return {
        __proto__: null,
        "./designer_bg.js": import0,
    };
}

const lAudioContext = (typeof AudioContext !== 'undefined' ? AudioContext : (typeof webkitAudioContext !== 'undefined' ? webkitAudioContext : undefined));
function wasm_bindgen_642d14a50fc440ff___convert__closures_____invoke_______true_(arg0, arg1) {
    wasm.wasm_bindgen_642d14a50fc440ff___convert__closures_____invoke_______true_(arg0, arg1);
}

function wasm_bindgen_642d14a50fc440ff___convert__closures_____invoke_______true__1_(arg0, arg1) {
    wasm.wasm_bindgen_642d14a50fc440ff___convert__closures_____invoke_______true__1_(arg0, arg1);
}

function wasm_bindgen_642d14a50fc440ff___convert__closures_____invoke___web_sys_13772816b5501337___features__gen_FocusEvent__FocusEvent______true_(arg0, arg1, arg2) {
    wasm.wasm_bindgen_642d14a50fc440ff___convert__closures_____invoke___web_sys_13772816b5501337___features__gen_FocusEvent__FocusEvent______true_(arg0, arg1, arg2);
}

const WebFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_web_free(ptr >>> 0, 1));

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

const CLOSURE_DTORS = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(state => wasm.__wbindgen_destroy_closure(state.a, state.b));

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function getArrayF32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function getArrayI16FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getInt16ArrayMemory0().subarray(ptr / 2, ptr / 2 + len);
}

function getArrayI32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getInt32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function getArrayI8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getInt8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(wasm.__wbindgen_externrefs.get(mem.getUint32(i, true)));
    }
    wasm.__externref_drop_slice(ptr, len);
    return result;
}

function getArrayU16FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint16ArrayMemory0().subarray(ptr / 2, ptr / 2 + len);
}

function getArrayU32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

let cachedFloat32ArrayMemory0 = null;
function getFloat32ArrayMemory0() {
    if (cachedFloat32ArrayMemory0 === null || cachedFloat32ArrayMemory0.byteLength === 0) {
        cachedFloat32ArrayMemory0 = new Float32Array(wasm.memory.buffer);
    }
    return cachedFloat32ArrayMemory0;
}

let cachedInt16ArrayMemory0 = null;
function getInt16ArrayMemory0() {
    if (cachedInt16ArrayMemory0 === null || cachedInt16ArrayMemory0.byteLength === 0) {
        cachedInt16ArrayMemory0 = new Int16Array(wasm.memory.buffer);
    }
    return cachedInt16ArrayMemory0;
}

let cachedInt32ArrayMemory0 = null;
function getInt32ArrayMemory0() {
    if (cachedInt32ArrayMemory0 === null || cachedInt32ArrayMemory0.byteLength === 0) {
        cachedInt32ArrayMemory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachedInt32ArrayMemory0;
}

let cachedInt8ArrayMemory0 = null;
function getInt8ArrayMemory0() {
    if (cachedInt8ArrayMemory0 === null || cachedInt8ArrayMemory0.byteLength === 0) {
        cachedInt8ArrayMemory0 = new Int8Array(wasm.memory.buffer);
    }
    return cachedInt8ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
}

let cachedUint16ArrayMemory0 = null;
function getUint16ArrayMemory0() {
    if (cachedUint16ArrayMemory0 === null || cachedUint16ArrayMemory0.byteLength === 0) {
        cachedUint16ArrayMemory0 = new Uint16Array(wasm.memory.buffer);
    }
    return cachedUint16ArrayMemory0;
}

let cachedUint32ArrayMemory0 = null;
function getUint32ArrayMemory0() {
    if (cachedUint32ArrayMemory0 === null || cachedUint32ArrayMemory0.byteLength === 0) {
        cachedUint32ArrayMemory0 = new Uint32Array(wasm.memory.buffer);
    }
    return cachedUint32ArrayMemory0;
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function makeClosure(arg0, arg1, f) {
    const state = { a: arg0, b: arg1, cnt: 1 };
    const real = (...args) => {

        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        try {
            return f(state.a, state.b, ...args);
        } finally {
            real._wbg_cb_unref();
        }
    };
    real._wbg_cb_unref = () => {
        if (--state.cnt === 0) {
            wasm.__wbindgen_destroy_closure(state.a, state.b);
            state.a = 0;
            CLOSURE_DTORS.unregister(state);
        }
    };
    CLOSURE_DTORS.register(real, state, state);
    return real;
}

function makeMutClosure(arg0, arg1, f) {
    const state = { a: arg0, b: arg1, cnt: 1 };
    const real = (...args) => {

        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally {
            state.a = a;
            real._wbg_cb_unref();
        }
    };
    real._wbg_cb_unref = () => {
        if (--state.cnt === 0) {
            wasm.__wbindgen_destroy_closure(state.a, state.b);
            state.a = 0;
            CLOSURE_DTORS.unregister(state);
        }
    };
    CLOSURE_DTORS.register(real, state, state);
    return real;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    for (let i = 0; i < array.length; i++) {
        const add = addToExternrefTable0(array[i]);
        getDataViewMemory0().setUint32(ptr + 4 * i, add, true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasm;
function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    wasmModule = module;
    cachedDataViewMemory0 = null;
    cachedFloat32ArrayMemory0 = null;
    cachedInt16ArrayMemory0 = null;
    cachedInt32ArrayMemory0 = null;
    cachedInt8ArrayMemory0 = null;
    cachedUint16ArrayMemory0 = null;
    cachedUint32ArrayMemory0 = null;
    cachedUint8ArrayMemory0 = null;
    wasm.__wbindgen_start();
    return wasm;
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            } catch (e) {
                const validResponse = module.ok && expectedResponseType(module.type);

                if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else { throw e; }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        } else {
            return instance;
        }
    }

    function expectedResponseType(type) {
        switch (type) {
            case 'basic': case 'cors': case 'default': return true;
        }
        return false;
    }
}

function initSync(module) {
    if (wasm !== undefined) return wasm;


    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) {
            ({module} = module)
        } else {
            console.warn('using deprecated parameters for `initSync()`; pass a single object instead')
        }
    }

    const imports = __wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }
    const instance = new WebAssembly.Instance(module, imports);
    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
    if (wasm !== undefined) return wasm;


    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
            ({module_or_path} = module_or_path)
        } else {
            console.warn('using deprecated parameters for the initialization function; pass a single object instead')
        }
    }

    if (module_or_path === undefined) {
        module_or_path = new URL('designer_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof module_or_path === 'string' || (typeof Request === 'function' && module_or_path instanceof Request) || (typeof URL === 'function' && module_or_path instanceof URL)) {
        module_or_path = fetch(module_or_path);
    }

    const { instance, module } = await __wbg_load(await module_or_path, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
